import "react-toastify/dist/ReactToastify.css";
import AssessmentDiscussionChart from "../../components/Common/Charts/PlotBarChart";
import AssessmentDiscussionDraftChart from "../../components/Common/Charts/AssessmentDiscussionDraftChart";
import OnetoOneSessionQualityScore from "../../components/Common/Charts/onetoonesessionqualityscore";
import ClarityScoreChart from "../../components/Common/Charts/clartyscorechart";
import EngagementScoreChart from "../../components/Common/Charts/engagementscorechart";
import Highcharts from "highcharts";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import PlotBarChart from "./PlotBarChart";
import React, { useEffect, useRef, useState } from "react";
import StudentListTable from "./studentlist";
import StudentSentimentChart from "../../components/Common/Charts/StudentSentimentChart";
import TeacherTable from "./TeachersTable";
import TopicDiscussedTab from "../../components/Common/TopicDiscussedTab/TopicDiscussedTab";
import WebinarInsightsTab from "../../components/Common/WebinarInsightsTab/WebinarInsightsTab";
import axios from "axios";
import { CardContent, Typography } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import WebinarAverageCharts from "./WebinarAverageCharts";
import ReactDOM from 'react-dom';
import { ChartTitle, withChartNavigation, weekNumberFromCategory } from "../../components/Common/ChartLink/ChartLink";



import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Spinner,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);



// Tab names used on this page
const TAB = {
  STUDENT_LIST: 'Student List',
  ONE_TO_ONE: '1-1 Session Insights',
  GROUP_SESSION: 'Group Session Insights',
};

// Function to store selected items in sessionStorage
const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify([...value])); // Convert Set to array before storing
};

// // Function to load selected items from sessionStorage
const loadFromSessionStorage = (key) => {
  const savedData = sessionStorage.getItem(key);
  return savedData ? new Set(JSON.parse(savedData)) : new Set(); // Parse and convert back to Set
};

// Function to remove selected items from sessionStorage
const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

const IndividualUnitReport = () => {
  document.title = 'Linc Quality Hub';
  const [customActiveTab, setcustomActiveTab] = useState('1');
  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [unitDropdownOpen, setUnitDropdownOpen] = useState(false);

  const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false);
  const [milestoneDropdownOpen, setMilestoneDropdownOpen] = useState(false);
  const [milestonetypeDropdownOpen, setMilestonetypeDropdownOpen] =
    useState(false);
  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [selectedUnits, setSelectedUnits] = useState(new Set());
  const [selectedTeachers, setSelectedTeachers] = useState(new Set());
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms
  const [selectedMilestones, setSelectedMilestones] = useState(new Set());
  const [selectedMilestonestype, setSelectedMilestonestype] = useState(
    new Set(),
  );
  const [selectedWeeks, setSelectedWeeks] = useState(new Set());
  // console.log("selectedWeeks",selectedWeeks);

  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [appliedUnit, setAppliedUnit] = useState(new Set()); // New state for applied terms
  const [appliedmilestonetype, setAppliedMilestonetype] = useState(new Set()); // New state for applied terms
  const [appliedmilestone, setAppliedMilestone] = useState(new Set());
  const [appliedPrograms, setAppliedPrograms] = useState(new Set()); // New state for applied terms
  const [appliedWeeks, setAppliedWeeks] = useState(new Set()); // New state for applied terms

  const [cardsData, setCardsData] = useState(null);
  // State for fetched data
  const [universities, setUniversities] = useState([]);
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]); // To store timeline terms
  const [timelineUnit, setTimelineUnit] = useState([]); // To store timeline terms
  const [programs, setPrograms] = useState([]);
  const [weeks, setWeeks] = useState([]);
  const [teacherNameCategories, setTeacherNameCategories] = useState([]);
  const [engagementPercentageValues, setEngagementPercentageValues] = useState([]);
  const [gradingTeacherNamesbyteacher, setGradingTeacherNames] = useState([]);
  const [gradingScoresbyTeacher, setGradingScores] = useState([]);

  const [weekDropdownOpen, setWeekDropdownOpen] = useState(false);
  const [weekSearch, setWeekSearch] = useState('');
  const [loadingFilter, setLoadingFilters] = useState(false);

  // // console.log("weeks", weeks)

  const [timelineMilestone, setTimelineMilestone] = useState([]);
  const [timelineMilestonetype, setTimelineMilestonetype] = useState([]);

  const [loading, setLoading] = useState(true); // New loading state
  const [loading1, setLoading1] = useState(false); // New loading state
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [activeYear, setActiveYear] = useState(null);

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('all');


    // Week number of the clicked bar (e.g. 47). Cleared on manual tab change.
  const [drillWeek, setDrillWeek] = useState(null);
  const [drillSubTab, setDrillSubTab] = useState(null);

  // const toggleTab = (tab) => {
  //   setActiveTab(tab);
  //   setDrillWeek(null);

  //   setDrillSubTab(null);
  // };

  const toggleTab = (tab) => {
  ReactDOM.flushSync(() => {
    setDrillWeek(null);
    setDrillSubTab(null);
  });
  setActiveTab(tab);
};

  // Function to handle tab change
  // const toggleTab = (tab) => {
  //   setActiveTab(tab);
  // };


  const tabsRef = useRef(null);

  // const goToTab = (tab, week = null) => {
  // setActiveTab(tab);
  // setDrillWeek(week);
//   const goToTab = (tab, week = null, subTab = null) => {

//     console.log('[goToTab] Unit ', tab, week, subTab);
//   setActiveTab(tab);
//   setDrillWeek(week);
//   setDrillSubTab(subTab);

//   setTimeout(
//     () => tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
//     50,
//   );
// };


const goToTab = (tab, week = null, subTab = null) => {
  console.log('[goToTab] Unit ', tab, week, subTab);

  // set week/subTab FIRST and force them to flush before the tab switch
  // so the child never mounts with a stale/null week
  ReactDOM.flushSync(() => {
    setDrillWeek(week);
    setDrillSubTab(subTab);
  });

  setActiveTab(tab);

  setTimeout(
    () => tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
    50,
  );
};

// For charts whose x-axis is weeks: bar click opens `tab` with that week preselected
// const chartNav = (options, tab) =>
//   withChartNavigation(options, (pt) =>
//     goToTab(tab, weekNumberFromCategory(pt.category)),
//   );

const chartNav = (options, tab, subTab = null) =>
  withChartNavigation(options, (pt) =>
    goToTab(tab, weekNumberFromCategory(pt.category), subTab),
  );


  // Names can differ in case/spacing between the two APIs, so normalize first
  const normalizeName = (name) =>
    (name || '').toLowerCase().replace(/\s+/g, ' ').trim();
  
  // // Open a student's profile from the flagged-students table
  // const handleFlaggedStudentClick = ({ studentName }) => {
  //   const target = normalizeName(studentName);
  
  //   const matches = (studentList || []).filter(
  //     (s) => normalizeName(s.full_name) === target,
  //   );
  
  //   if (matches.length === 0) {
  //     toast.error(`Could not find "${studentName}" in the Student List.`);
  //     return;
  //   }
  //   if (matches.length > 1) {
  //     toast.error(
  //       `More than one student is named "${studentName}". Please open them from the Student List.`,
  //     );
  //     return;
  //   }
  
  //   const student = matches[0];
  
  //   navigate('/individualteacher/studentDetails', {
  //     state: {
  //       StudentName: student.full_name,
  //       Studentid: student.student, // real student id, not student_classroom_id
  //       appliedUniversities:
  //         (appliedUniversities.size > 0 && appliedUniversities) ||
  //         Deatilsofteacher?.appliedUniversities,
  //       appliedPrograms:
  //         (appliedPrograms.size > 0 && appliedPrograms) ||
  //         Deatilsofteacher?.appliedPrograms,
  //       appliedTimelines:
  //         (appliedTimelines.size > 0 && appliedTimelines) ||
  //         Deatilsofteacher?.appliedTimelines,
  //       appliedTerms:
  //         (appliedTerms.size > 0 && appliedTerms) ||
  //         Deatilsofteacher?.appliedTerms,
  //       appliedUnit:
  //         (appliedUnit.size > 0 && appliedUnit) ||
  //         (Deatilsofteacher?.unit_id
  //           ? new Set([Deatilsofteacher.unit_id])
  //           : new Set()),
  //       appliedTeacher:
  //         (appliedTeacher.size > 0 && appliedTeacher) ||
  //         (Deatilsofteacher?.teacherid
  //           ? new Set([Deatilsofteacher.teacherid])
  //           : new Set()),
  //     },
  //   });
  // };

  const handleFlaggedStudentClick = ({ studentName }) => {
  const target = normalizeName(studentName);

  const matches = (StudentLIst || []).filter(
    (s) => normalizeName(s.full_name) === target,
  );

  if (matches.length === 0) {
    toast.error(`Could not find "${studentName}" in the Student List.`);
    return;
  }
  if (matches.length > 1) {
    toast.error(
      `More than one student is named "${studentName}". Please open them from the Student List.`,
    );
    return;
  }

  const student = matches[0];


    navigate('/individalunitreport/studentdeatilsunit', {
    state: {
      StudentName: student.full_name,
      Studentid: student.student,
      shealth: student.shealth,
      appliedUniversities:
        (appliedUniversities.size > 0 && appliedUniversities) ||
        Deatilsofunits?.appliedUniversities,
      appliedPrograms:
        (appliedPrograms.size > 0 && appliedPrograms) ||
        Deatilsofunits?.appliedPrograms,
      appliedTimelines:
        (appliedTimelines.size > 0 && appliedTimelines) ||
        Deatilsofunits?.appliedTimelines,
      appliedTerms:
        (appliedTerms.size > 0 && appliedTerms) ||
        Deatilsofunits?.appliedTerms,
      appliedUnit:
        (appliedUnit.size > 0 && appliedUnit) ||
        (Deatilsofunits?.unit_id
          ? new Set([Deatilsofunits.unit_id])
          : new Set()),
      appliedTeacher: new Set(),
    },
  });
  

  // navigate('/individualteacher/studentDetails', {
  //   state: {
  //     StudentName: student.full_name,
  //     Studentid: student.student,
  //     appliedUniversities:
  //       (appliedUniversities.size > 0 && appliedUniversities) ||
  //       Deatilsofunits?.appliedUniversities,
  //     appliedPrograms:
  //       (appliedPrograms.size > 0 && appliedPrograms) ||
  //       Deatilsofunits?.appliedPrograms,
  //     appliedTimelines:
  //       (appliedTimelines.size > 0 && appliedTimelines) ||
  //       Deatilsofunits?.appliedTimelines,
  //     appliedTerms:
  //       (appliedTerms.size > 0 && appliedTerms) ||
  //       Deatilsofunits?.appliedTerms,
  //     appliedUnit:
  //       (appliedUnit.size > 0 && appliedUnit) ||
  //       (Deatilsofunits?.unit_id
  //         ? new Set([Deatilsofunits.unit_id])
  //         : new Set()),
  //   },
  // });
};

// const goToTab = (tab) => {
//   toggleTab(tab); // switch the tab
//   setTimeout(
//     () => tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
//     50,
//   ); // scroll up to the tabs so the user sees the new content
// };

/* =======================
   REFS (FLOW CONTROL)
======================= */
const isUrlFlowRef = useRef(false);
const isUrlFlowDoneRef = useRef(false);
const isApplyingRef = useRef(false);

/* =======================
   ROUTE PARAMS
======================= */
const location = useLocation();
const query = new URLSearchParams(location.search);

const urlUniversity = query.get('universityid');
const urlProgram = query.get('program_id');
const urlYear = query.get('year');
const urlTerm = query.get('term');
const urlUnit = query.get('unit_id');
const urlActiveTab = query.get('activeTab');
const urlWeek = query.get('week');


const hasUrlParams =
  urlUniversity || urlProgram || urlYear || urlTerm || urlUnit;

/* =======================
   ACTIVE TAB
======================= */
useEffect(() => {
  if (urlActiveTab) {
    setActiveTab(urlActiveTab);
  }
}, []);

/* =======================
   URL FLOW — STEP 1
   SET UNIVERSITY
======================= */
useEffect(() => {
  if (urlUniversity) {
    isUrlFlowRef.current = true; // 🔑 LOCK MANUAL FLOW

    const uniSet = new Set([Number(urlUniversity)]);
    setSelectedUniversities(uniSet);
    setAppliedUniversities(uniSet);

    saveToSessionStorage('appliedUniversities', uniSet);
  }
}, []);

/* =======================
   MANUAL FLOW
   UNIVERSITY → PROGRAMS
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (selectedUniversities.size > 0) {
    fetchDataPrograms();
  }
}, [selectedUniversities]);

/* =======================
   URL FLOW — STEP 2
   SET PROGRAM
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlProgram) return;
  if (!programs.length) return;

  const progSet = new Set([Number(urlProgram)]);
  setSelectedPrograms(progSet);
  setAppliedPrograms(progSet);

  saveToSessionStorage('appliedPrograms', progSet);
}, [programs]);

/* =======================
   MANUAL FLOW
   PROGRAM → YEAR
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (
    selectedUniversities.size > 0 &&
    selectedPrograms.size > 0
  ) {
    fetchDataYear();
  }
}, [selectedUniversities, selectedPrograms]);

/* =======================
   URL FLOW — STEP 3
   SET YEAR
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlYear) return;
  if (!timelineYears.length) return;

  const yearSet = new Set([urlYear]);
  setSelectedTimelines(yearSet);
  setAppliedTimelines(yearSet);

  saveToSessionStorage('appliedTimelinesiur', yearSet);
}, [timelineYears]);

/* =======================
   MANUAL FLOW
   YEAR → TERM
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (
    selectedUniversities.size > 0 &&
    selectedTimelines.size > 0
  ) {
    fetchDataTerm();
  }
}, [selectedTimelines]);

/* =======================
   URL FLOW — STEP 4
   SET TERM
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlTerm) return;
  if (!timelineTerms.length) return;

  const termSet = new Set([urlTerm]);
  setSelectedTerms(termSet);
  setAppliedTerms(termSet);

  saveToSessionStorage('appliedTermsiur', termSet);
}, [timelineTerms]);

/* =======================
   MANUAL FLOW
   TERM → UNIT
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (
    selectedUniversities.size > 0 &&
    selectedTimelines.size > 0 &&
    selectedTerms.size > 0
  ) {
    fetchDatawithYearUnit();
  }
}, [selectedTerms]);

/* =======================
   URL FLOW — STEP 5
   SET UNIT
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlUnit) return;
  if (!timelineUnit.length) return;

  const unitSet = new Set([Number(urlUnit)]);
  setSelectedUnits(unitSet);
  setAppliedUnit(unitSet);

  saveToSessionStorage('appliedunitiur', unitSet);
}, [timelineUnit]);

/* =======================
   FINAL APPLY (URL FLOW)
======================= */
useEffect(() => {
  if (
    !hasUrlParams ||
    isUrlFlowDoneRef.current ||
    isApplyingRef.current
  ) return;

  if (
    selectedUniversities.size &&
    selectedPrograms.size &&
    selectedTimelines.size &&
    selectedTerms.size &&
    selectedUnits.size
  ) {
    isApplyingRef.current = true;

    handleApply(); // ✅ APPLY ONCE

    isUrlFlowDoneRef.current = true;
    isApplyingRef.current = false;
    isUrlFlowRef.current = false; // 🔓 UNLOCK MANUAL FLOW
  }
}, [selectedUnits]);



  // useEffect(() => {
  //   // update params in url like ?activeTab=Call Perfomance
  // }, [activeTab])
  const [searchParams, setSearchParams] = useSearchParams(); // Get searchParams object and setter

  // Effect to update URL search params when activeTab changes
  useEffect(() => {
    // Create a new URLSearchParams object based on current search params
    const newSearchParams = new URLSearchParams(searchParams.toString());

    // Set or update the 'activeTab' parameter
    newSearchParams.set('activeTab', activeTab);

    // Update the URL without causing a full page reload
    setSearchParams(newSearchParams);

    // You can also add a console log to see the effect
    // console.log(`URL updated: ?activeTab=${activeTab}`);
  }, [activeTab, searchParams, setSearchParams]); // Dependencies: activeTab, and the searchParams utilities

  useEffect(() => {
    const tabFromUrl = searchParams.get('activeTab');
    if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, []); // Run only once on mount to read initial URL state

  //messeage responsiveness  chart
  const [metricsData, setMetricsData] = useState(null);
  const [tableData, SettableData] = useState(null);
  const [tacherTableData, SetTeacherTableData] = useState(null);

  //teacher tab chart
  const [teachersChartData, setTeachersChartData] = useState(null);
  const [teachersChartDataMidTerm, setTeachersChartDataMidTerm] =
    useState(null);
  const [teachersChartDataEndTerm, setTeachersChartDataEndTerm] =
    useState(null);
  const [teachersChartDataWeeks, setTeachersChartDataWeeks] = useState(null);
  const [timeCommitedData, setTimeCommitedData] = useState(null);
  const [Responsiveness, setResponsiveness] = useState(null);
  const [Call_performance_response, setCall_performance_response] =
    useState(null);
  const [webinarPerfomanceData, setwebinar_performance_response] =
    useState(null);
  //insights
  const [InsightsQuestions, SetInsightsQuestions] = useState(null);
  const [InsightsTopics, SetInsightsTopics] = useState(null);
  const [StudentLIst, SetStudentList] = useState(null);
  const [isightsData, setInsightsData] = useState(null);

  // console.log('insightsData', isightsData);
  // console.log('chart data', InsightsQuestions);

  const [assesmentDiscussionChart, setassesmentDiscussionChart] =
    useState(null);
  const [resetTrigger, setResetTrigger] = useState(0);

  //search option
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');

  const [milestoneTypeSearch, setMilestoneTypeSearch] = useState('');
  const [milestoneSearch, setMilestoneSearch] = useState('');
  const [unitSearch, setUnitSearch] = useState('');

  const navigate = useNavigate();
  const Deatilsofunits = location?.state;
  console.log('Deatilsofunits', Deatilsofunits);
  const UnitName = location.state?.UnitName;

  useEffect(() => {
    if (Deatilsofunits) {
      removeFromSessionStorage('appliedUniversities');
      removeFromSessionStorage('appliedPrograms');
      removeFromSessionStorage('appliedTimelinesiur');
      removeFromSessionStorage('appliedTermsiur');
      removeFromSessionStorage('appliedmilestoetypeiur');
      removeFromSessionStorage('appliedmilestoeiur');
      removeFromSessionStorage('appliedunitiur');
      removeFromSessionStorage('appliedWeeksiur');
      removeFromSessionStorage('selectedWeeksiur');

      removeFromSessionStorage('selectedPrograms');
      removeFromSessionStorage('selectedUniversities');
      removeFromSessionStorage('selectedTimelinesiur');
      removeFromSessionStorage('selectedTermsiur');
      removeFromSessionStorage('selectedmilestonetypeiur');
      removeFromSessionStorage('selectedmilestoneiur');
      removeFromSessionStorage('selecetdunitiur');
    }
  }, [Deatilsofunits]);

  useEffect(() => {
    setLoading(true);
    setAppliedUniversities(loadFromSessionStorage('appliedUniversities'));
    setAppliedPrograms(loadFromSessionStorage('appliedPrograms'));
    setAppliedTimelines(loadFromSessionStorage('appliedTimelinesiur'));
    setAppliedTerms(loadFromSessionStorage('appliedTermsiur'));
    setAppliedMilestonetype(loadFromSessionStorage('appliedmilestoetypeiur'));
    setAppliedMilestone(loadFromSessionStorage('appliedmilestoeiur'));
    setAppliedUnit(loadFromSessionStorage('appliedunitiur'));
    setAppliedWeeks(loadFromSessionStorage('appliedWeeksiur'));

    setSelectedWeeks(loadFromSessionStorage('selectedWeeksiur'));
    setSelectedPrograms(loadFromSessionStorage('appliedPrograms'));
    setSelectedUniversities(loadFromSessionStorage('appliedUniversities'));
    setSelectedTimelines(loadFromSessionStorage('selectedTimelinesiur'));
    setSelectedTerms(loadFromSessionStorage('selectedTermsiur'));
    setSelectedMilestonestype(
      loadFromSessionStorage('selectedmilestonetypeiur'),
    );
    setSelectedMilestones(loadFromSessionStorage('selectedmilestoneiur'));
    setSelectedUnits(loadFromSessionStorage('selecetdunitiur'));
    // teacher qc

    if (Deatilsofunits?.unit_id) {
      const unitset = new Set([Deatilsofunits.unit_id]);
      setAppliedUnit(unitset);
      saveToSessionStorage('appliedunitiur', unitset);
      setSelectedUnits(unitset);
      saveToSessionStorage('selecetdunitiur', unitset);

      const university = new Set([...Deatilsofunits.appliedUniversities]);
      setAppliedUniversities(university);
      setSelectedUniversities(university);
      saveToSessionStorage('appliedUniversities', Array.from(university));
      saveToSessionStorage('selectedUniversities', Array.from(university));

      const programtq = new Set([...Deatilsofunits.appliedPrograms]);
      setAppliedPrograms(programtq);
      saveToSessionStorage('appliedPrograms', Array.from(programtq));
      setSelectedPrograms(programtq);
      saveToSessionStorage('selectedPrograms', Array.from(programtq));

      // const miestoneunitqctype = new Set([...Deatilsofunits.appliedmilestonetype]);
      // setAppliedMilestonetype(miestoneunitqctype);
      // saveToSessionStorage('appliedmilestoetypeiur', Array.from(miestoneunitqctype));
      // setSelectedMilestonestype(miestoneunitqctype);
      // saveToSessionStorage('selectedmilestonetypeiur', Array.from(miestoneunitqctype));

      // const miestoneunitqc = new Set([...Deatilsofunits.appliedmilestone]);
      // setAppliedMilestone(miestoneunitqc);
      // saveToSessionStorage('appliedmilestoeiur', Array.from(miestoneunitqc));
      // setSelectedMilestones(miestoneunitqc);
      // saveToSessionStorage('selectedmilestoneiur', Array.from(miestoneunitqc));

      if (Deatilsofunits?.appliedTerms && Deatilsofunits?.appliedTimelines) {
        const termArray = Array.from(Deatilsofunits.appliedTerms); // Convert Set to Array
        const yearArray = Array.from(Deatilsofunits.appliedTimelines); // Convert Set to Array

        setAppliedTerms(new Set(termArray)); // Update state if needed
        setAppliedTimelines(new Set(yearArray)); // Update state if needed
        setSelectedTimelines(new Set(yearArray));
        setSelectedTerms(new Set(termArray));
        saveToSessionStorage('appliedTermsiur', termArray); // Save as array
        saveToSessionStorage('selectedTermsiur', termArray); // Save as array

        saveToSessionStorage('appliedTimelinesiur', yearArray);
        saveToSessionStorage('selectedTimelinesiur', yearArray); // Save as array
        // Save as array
        // setSelectedPrograms(loadFromSessionStorage('selectedProgramsteacherqc'));
        // setSelectedUniversities(loadFromSessionStorage('selectedUniversitiesteacherqc'));
        // setSelectedTimelines(loadFromSessionStorage('selectedTimelinesteacherqc'));
        // setSelectedTerms(loadFromSessionStorage('selectedTermsteacherqc'));
      }
    } else {
    }
    setLoading(false);
  }, []);

  const user_token = localStorage.getItem('usertoken');

  const assessmentDiscussedColor = ['#A9C6FE']; // Orange Red

  const slidesUsedColor = ['#7cb9b2']; // Dark Goldenrod
  const interactiveToolsColor = ['#82a4b1']; // Dark Slate Blue
  const [webinarAverageChartsDataProps, setwebinarAverageChartsDataProps] =
    useState(null);

  useEffect(() => {
    // webinar_performance_response. keymaps
    if (webinarPerfomanceData) {
      const webinarAverageChartsDataProps = {
        averageOverallQualityData:
          webinarPerfomanceData?.weekly_overall_session_quality_score,
        averageClarityScoreData: webinarPerfomanceData?.weekly_clarity_score,
        averageWebinarCoverageData:
          webinarPerfomanceData?.weekly_webinar_coverage_score,
        averageEngagementScoreData:
          webinarPerfomanceData?.weekly_instructor_engagement_score, //????????????????????????????????
        averageStudentSentimentData:
          webinarPerfomanceData?.weekly_student_sentiment_score,
        averageResponseScoreData:
          webinarPerfomanceData?.weekly_responsiveness_score,
        averageTeacherTimeSpokenData:
          webinarPerfomanceData?.weekly_instructor_talktime,
        averageFluencyScoreData: webinarPerfomanceData?.weekly_fluency_score,
      };
      setwebinarAverageChartsDataProps(webinarAverageChartsDataProps);
    } else {
      setwebinarAverageChartsDataProps(null);
    }
  }, [webinarPerfomanceData]);

  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;

      case 'milestoneType':
        setMilestoneTypeSearch(value);
        break;
      case 'milestone':
        setMilestoneSearch(value);
        break;
      case 'unitSearch':
        setUnitSearch(value); // Set the unit search state when typed
        break;
      case 'week':
        setWeekSearch(value);
        break;

      default:
        break;
    }
  };

  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return programs.filter(([id, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };
  const filterWeeks = (weekSearch) => {
    return weeks.filter((week) => week.includes(weekSearch));
  };
  const filterMilestoneTypes = (search) => {
    return timelineMilestonetype.filter((type) =>
      type.toLowerCase().includes(search.toLowerCase()),
    );
  };

  const filterMilestones = (search) => {
    return timelineMilestone.filter((milestone) =>
      milestone.toString().includes(search),
    );
  };
  const filterUnits = (unitSearch) => {
    return timelineUnit.filter((unit) =>
      unit.name.toLowerCase().includes(unitSearch.toLowerCase()),
    );
  };

  // // console.log("chart", tableData)
  // charts state start 1-1 stud engage
  const [studenagechart, setStudenageChart] = useState({
    new: '0%',
    returning: '0%',
    total: '0%',
  });

  const clusteredColumnChartOptions = {
    chart: {
      type: 'column', // Column chart
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: ['New Students', 'Returning  Students', 'All Students'], // Categories for the grouped columns
      title: {
        text: null, // No title for the X-axis
      },
      crosshair: true, // Enable crosshair
    },
    yAxis: {
      min: 0,
      max: 100, // Percentage range from 0 to 100
      tickInterval: 20, // Adjust tick interval as necessary
      title: {
        text: '% Students Engaged', // Y-axis title is percentage
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Display percentage on the Y-axis
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    plotOptions: {
      column: {
        grouping: true, // Ensure columns are grouped
        borderWidth: 0, // Remove border around columns
        pointWidth: 10, // Set point width to 10
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Set label text color to black
          style: {
            fontSize: '10px', // Set font size for the labels
            fontWeight: 'bold', // Make labels bold
          },
          verticalAlign: 'middle', // Align vertically in the middle
          align: 'left', // Position the labels to the right of the bars
          crop: false, // Ensure labels are visible even if they are outside the plot area
          overflow: 'none', // Do not hide labels that overflow
          x: 10, // Offset the labels to the right (adjust if necessary)
          formatter: function () {
            return this.y + '%'; // Append % symbol to the label
          },
        },
      },
    },
    series: [
      {
        name: ' Student Engagement',
        colorByPoint: true, // Color each column in the series differently
        data: [
          {
            y: parseInt(studenagechart.new) || 0, // New Students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#F9C78D '],
                [0.5, '#FFE9D7'],
                [1, ' #FFF3E7'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(studenagechart.returning) || 0, // Returning Students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [0.5, '#CEDDFA'],
                [1, '#F2F5FC'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(studenagechart.total) || 0, // Total Students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, ' #FF9B9B'],
                [0.5, '#FDD8D8'],
                [1, '#FDE9EB'],
              ],
            },
            pointPadding: 0.1,
          },
        ],
        // pointPlacement: 'on', // Place columns exactly on their category positions
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts branding
    },
    exporting: {
      enabled: true, // Enable chart exporting options
      chartOptions: {
        title: {
          text: ' Student Engagement',
        },
      },
    },
  };

  //Census Melt Rate (%) start second chart
  const [censusdropchart, setCensusdropChart] = useState({
    new: '0%',
    returning: '0%',
    total: '0%',
  });

  const clusteredColumnChartOptionsForCensus = {
    chart: {
      type: 'column', // Set chart type to 'column' for grouped bars
      backgroundColor: 'transparent', // Transparent background
    },
    title: {
      text: null, // No chart title
    },
    xAxis: {
      categories: ['New Students', 'Returning Students', 'All Students'], // Categories for the grouped columns
      title: {
        text: null, // No title for the X-axis
      },
      crosshair: true, // Enable crosshair for better readability
    },
    yAxis: {
      min: 0,
      max: 100, // Percentage scale from 0 to 100
      tickInterval: 20, // Adjust tick interval as needed
      title: {
        text: ' Melt Rate (%)', // Y-axis title is percentage
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Format labels as percentage
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    plotOptions: {
      column: {
        grouping: true, // Group columns together by category
        borderWidth: 0, // No borders for the columns
        pointWidth: 10, // Width of the columns
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Label text color
          style: {
            fontSize: '10px', // Label font size
            fontWeight: 'bold', // Bold labels
          },
          verticalAlign: 'middle', // Align labels vertically in the middle
          align: 'left', // Position labels to the left of the bars
          crop: false, // Ensure labels are visible even if they overflow
          overflow: 'none', // Do not hide overflowing labels
          x: 10,
          formatter: function () {
            return this.y + '%'; // Append % symbol to the label
          },
        },
      },
    },
    series: [
      {
        name: 'Census Melt Rate (%)', // Series name
        colorByPoint: true, // Color each column individually
        data: [
          {
            y: parseInt(censusdropchart.new) || 0, // New students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#F9C78D '],
                [0.5, '#FFE9D7'],
                [1, ' #FFF3E7'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(censusdropchart.returning) || 0, // Returning students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [0.5, '#CEDDFA'],
                [1, '#F2F5FC'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(censusdropchart.total) || 0, // Total students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, ' #FF9B9B'],
                [0.5, '#FDD8D8'],
                [1, '#FDE9EB'],
              ],
            },
            pointPadding: 0.1,
          },
        ],
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts branding
    },
    exporting: {
      enabled: true, // Enable chart exporting options
      chartOptions: {
        title: {
          text: 'Census Melt Rate (%)', // Title when exporting the chart
        },
      },
    },
  };

  const [studentReengagementChart, setStudentReengagementChart] =
    useState(null);

  const [avertimeperstudchart, setAvertimeperstudchart] = useState({
    weeks: [],
    average_time_per_call: [],
    average_time_per_student: [],
  });

  const lineChartOptions1 = {
    chart: {
      type: 'line', // Line chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Updated title
    },
    xAxis: {
      categories: avertimeperstudchart.weeks || [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Duration (Min.)', // Y-axis label updated to reflect call time
      },
      labels: {
        formatter: function () {
          return this.value; // Add 'mins' to Y-axis labels
        },
      },
    },
    series: [
      {
        name: 'Avg. Session Time Per Student (Min.)', // Line 1 - Average time per student
        data: avertimeperstudchart.average_time_per_student || [],
        color: '#F4B3BF', // Color for this line
        marker: {
          enabled: true, // Show data points
        },
        dataLabels: {
          enabled: true, // Enable data labels
          formatter: function () {
            return this.y; // Add 'mins' to the label
          },
          style: {
            color: '#000', // Match the line color
            fontSize: '8px', // Adjust font size
            fontWeight: 'bold', // Make text bold if necessary
          },
        },
      },
      {
        name: 'Avg. Session Duration (Min.)', // Line 2 - Average time per call
        data: avertimeperstudchart.average_time_per_call || [],
        color: '#95B0F6', // Color for this line
        marker: {
          enabled: true, // Show data points
        },
        dataLabels: {
          enabled: true, // Enable data labels
          formatter: function () {
            return this.y; // Add 'mins' to the label
          },
          style: {
            color: '#000', // Match the line color
            fontSize: '8px', // Adjust font size
            fontWeight: 'bold', // Make text bold if necessary
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '1-1 Session Duration, by Week',
        },
      },
    },
  };
  const [assessstudHealthchart, setassessstudHealthchart] = useState({
    weeks: [],
    Extremely_behind_the_track: [],
    Slightly_behind_the_track: [],
    On_track: [],
    Not_available: [],
  });


  const studentHealthChartOptions = {
    chart: {
      type: 'line', // Line chart
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: assessstudHealthchart.weeks || [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: ' % Students Marked Behind Track',
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          formatter: function () {
            return this.y + '%'; // Adds % to each data point
          },
          enabled: true, // Enable data labels for each point
          style: {
            color: '#333', // Customize label color
            fontWeight: 'bold',
          },
        },
        enableMouseTracking: true, // Enable hover and tooltips
      },
    },
    series: [
      {
        name: 'On-Track',
        data: assessstudHealthchart.On_track || [],
        color: '#FEBEBC',
        dataLabels: {
          formatter: function () {
            return this.y + '%';
          },
          style: {
            color: '#000',
            fontWeight: 'bolt',
          },
        },
      },
      {
        name: 'Slightly Behind Track',
        data: assessstudHealthchart.Slightly_behind_the_track || [],
        color: '#BEFCCF',
        dataLabels: {
          formatter: function () {
            return this.y + '%';
          },
          style: {
            color: '#000',
            fontWeight: 'bolt',
          },
        },
      },
      {
        name: 'Extremely Behind Track',
        data: assessstudHealthchart.Extremely_behind_the_track || [],
        color: '#F6C389',
        dataLabels: {
          formatter: function () {
            return this.y + '%';
          },
          style: {
            color: '#000',
            fontWeight: 'bolt',
          },
        },
      },
      {
        name: 'Cannot Say / Not Available',
        data: assessstudHealthchart.Not_available || [],
        color: '#B7B8F9',
        dataLabels: {
          formatter: function () {
            return this.y + '%';
          },
          style: {
            color: '#000',
            fontWeight: 'bolt',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: ' Student Health',
        },
      },
    },
  };

  const [weekOnweekmsgcallchart, setWeekOnweekmsgCallChart] = useState({
    weeks: [],
    total_received_mail: [],
    total_received_sms: [],
    total_sent_mail: [],
    total_sent_sms: [],
  });

  const stackedGroupedChartOptions = {
    chart: {
      type: 'column', // Use 'column' for a vertical bar chart
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: weekOnweekmsgcallchart.weeks || [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Messages',
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: 'bold',
          color:
            (Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color) ||
            'gray',
        },
      },
    },
    plotOptions: {
      column: {
        // stacking: "normal", // Stack the columns
        grouping: true, // Group the columns
        dataLabels: {
          enabled: true, // Show data labels
        },
      },
    },
    series: [
      // {
      //   name: "Messages Sent",
      //   data: weekOnweekmsgcallchart.total_sent_sms || [],
      //   stack: "messages", // Stack for messages
      //   color: {
      //     linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
      //     stops: [
      //       [0, "#FCE6E8"], // Start color
      //       [1, "#FEBEBC"], // End color
      //     ],
      //   },
      //   pointWidth: "10",
      // },
      // {
      //   name: "Emails Sent",
      //   data: weekOnweekmsgcallchart.total_sent_mail || [],
      //   stack: "messages", // Stack for messages
      //   color: {
      //     linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
      //     stops: [
      //       [0, "#E9FEEF"], // Start color
      //       [1, "#BEFCCF"], // End color
      //     ],
      //   },
      //   pointWidth: "10",
      // },
      {
        name: 'Sent to Student',

        data: weekOnweekmsgcallchart.total_received_sms || [],
        stack: 'emails', // Stack for emails
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
          stops: [
            [0, '#FFE8D6'], // Start color
            [1, '#F6C389'], // End color
          ],
        },
        pointWidth: '10',
      },
      {
        name: 'Received from Student',
        data: weekOnweekmsgcallchart.total_received_mail || [],
        stack: 'emails', // Stack for emails
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
          stops: [
            [0, '#E6E4FB'], // Start color
            [1, '#B7B8F9'], // End color
          ],
        },
        pointWidth: '10',
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Messages Exchanged, by Week',
        },
      },
    },
  };

  const [callDetailsOverchart, SetcallDetailsOverchart] = useState({
    weekscallback: [],
    no_of_phone_calls: [],
    total_duration: [],
    total_duration_str: [],
  });

  const studentSessionchartRef = useRef();
  const combinedChartOptions = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: callDetailsOverchart.weekscallback,
      title: {
        text: 'Week',
      },
    },
    yAxis: [
      {
        title: {
          text: 'No. of Sessions',
        },
        min: 0,
        opposite: false, // Left axis
        allowDecimals: true,
      },
      {
        title: {
          text: 'Duration in Hours',
        },
        min: 0,
        opposite: true, // Right axis
        allowDecimals: true,
      },
    ],

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const index = this.points?.[0]?.point.index;
        const week = this.x;

        let tooltipContent = `<b>Week:</b> ${week}<br/>`;

        this.points.forEach((point) => {
          if (point.series.name === 'Session Duration (Hrs.)') {
            const durationStr = callDetailsOverchart.total_duration_str[index] || 'N/A';
            tooltipContent += `<span style="color:${point.color}">\u25CF</span> <b>${point.series.name}:</b> ${durationStr}<br/>`;
          } else {
            tooltipContent += `<span style="color:${point.color}">\u25CF</span> <b>${point.series.name}:</b> ${point.y}<br/>`;
          }
        });

        return tooltipContent;
      }
    },

    series: [
      {
        name: 'Number of Sessions',
        color: '#F9C890',
        data: callDetailsOverchart.no_of_phone_calls,
        type: 'line',
        yAxis: 0,
        dataLabels: { enabled: true },
        events: {
          legendItemClick: function () {
            const chart = studentSessionchartRef.current.chart;
            const yAxisIndex = this.yAxis.options.index || 0;
            const yAxis = chart.yAxis[yAxisIndex];
            const willHide = !this.visible; // current state before click
            setTimeout(() => {
              yAxis.update({
                min: 0,

                visible: !willHide,
                title: { text: !willHide ? 'No. of Sessions' : null },
              });
            }, 0);
          },
        },
      },
      {
        name: 'Session Duration (Hrs.)',
        type: 'column',
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#F2FFF6'],
            [1, '#BEF8CC'],
          ],
        },
        pointWidth: 10,

        data: callDetailsOverchart.total_duration.map(
          (item) => parseFloat(item) || 0,
        ),
        // callDetailsOverchart.total_duration_str

        yAxis: 1,
        dataLabels: {
          enabled: true,
          inside: true,
          align: 'right',
          x: -5,
          y: 0,
        },
        events: {
          legendItemClick: function () {
            const chart = studentSessionchartRef.current.chart;
            const yAxisIndex = this.yAxis.options.index || 1;
            const yAxis = chart.yAxis[yAxisIndex];
            const willHide = !this.visible;
            setTimeout(() => {
              yAxis.update({
                min: 0,

                visible: !willHide,
                title: { text: !willHide ? 'Duration in Hours' : null },
              });
            }, 0);
          },
        },
      },
    ],

    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          // format: "{y}",
          format: '{y:.1f}',
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '1-1 Session Details, by Week',
        },
      },
    },
  };



  const [phonevideoEngagedchart, SetphonevideoEngagedchart] = useState({
    weeks: [],
    phone_video_engaged: [],
    student_engaged_one_one: [],
  });

  const lineChartOptions = {
    chart: {
      type: 'line', // Line chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: phonevideoEngagedchart.weeks || [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      max: 100, // Assuming percentages range from 0 to 100
      title: {
        text: 'Students Engaged (%)',
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Add percentage sign
        },
      },
    },

    series: [
      {
        name: 'Students Engaged',
        data: phonevideoEngagedchart.student_engaged_one_one || [],
        color: '#F4B3BF', // Color for this line
        marker: {
          enabled: true, // Show data points
        },
      },
      {
        name: 'Students Engaged in 1-1 Sessions',
        data: phonevideoEngagedchart.phone_video_engaged || [],
        color: '#95B0F6', // Color for this line
        marker: {
          enabled: true, // Show data points
        },
      },
    ],
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true, // Enable data labels
          formatter: function () {
            return this.y + '%'; // Display value with a percentage sign
          },
          style: {
            color: '#000', // Optional: set data label color
            fontSize: '10px',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '  Week on Week Student Engagement',
        },
      },
    },
  };

  const [assessmentDiscussionChart, SetassessmentDiscussionChart] = useState({
    weeks: [],
    discussing_students_percentage: [],
  });

  const assessmentDiscussionChartOptions = {
    chart: {
      type: 'line',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: assessmentDiscussionChart.weeks || [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: '% Students Discussing Assessments',
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Append % symbol to Y-axis labels
        },
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      valueSuffix: '%', // Ensure percentage in the tooltip
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true,
        },
      },
    },
    series: [
      {
        name: 'Discussing Assessments',
        data: assessmentDiscussionChart.discussing_students_percentage || [],
        color: '#F9C68D',
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y + '%'; // Append % symbol to data labels
          },
          style: {
            color: '#000',
            fontSize: '8px',
            fontWeight: 'bold',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      chartOptions: {
        title: {
          text: 'Assessment Discussion with Students',
        },
      },
      enabled: true,
    },
  };


  const [oneToOneChart, setOneToOneChart] = useState({
    chart: {
      type: "column",
      backgroundColor: "transparent",
      marginTop: 40,
    },
    title: { text: null },
    xAxis: {
      categories: ["Audio", "Video"],
      title: { text: "Session Type" },
    },
    yAxis: {
      min: 0,
      title: { text: "Values" },
    },
    series: [
      {
        name: "Duration of 1-1 sessions",
        type: "column",
        data: [], // Dynamic
        pointWidth: 10,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, "#E1EAF9"],
            [1, "#B5D0FB"],
          ],
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} mins`;
          },
        },
      },
      {
        name: "Number of sessions",
        type: "line",
        data: [], // Dynamic
        color: "#FF9FA2",
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} successful`;
          },
        },
      },
    ],
    credits: { enabled: false },
    legend: { enabled: true },
  });


  const [GroupsessionQualitycorce, setGroupsessionQualitycorce] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Avg. Session Quality Score',
      },
      labels: {
        format: '{value}%',
      },
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
        fontSize: '12px',
        fontWeight: '500'
      },
    },

    series: [
      {
        name: 'Avg. Session Quality Score',
        data: [],
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E6E4FB'],
            [1, '#B7B8F9'],
          ],
        },
        pointWidth: 10,
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          format: '{y}%',
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Group Session Quality Score',
        },
      },
    },
  });


  const [Groupsessionbyweek, setGroupsessionbyweek] = useState({
    weeks: [],
    duration: [],
    count: [],

  });

  const Groupsessionbyweekchart = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: Groupsessionbyweek.weeks,
      title: {
        text: 'Weeks',
      },
    },
    yAxis: [
      {
        title: {
          text: 'Number of webinars',
        },
        min: 0,
        opposite: false, // Left axis
        allowDecimals: true,
      },
      {
        title: {
          text: 'Total duration (mins)',
        },
        min: 0,
        opposite: true, // Right axis
        allowDecimals: true,
      },
    ],

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const index = this.points?.[0]?.point.index;
        const week = Groupsessionbyweek.weeks[index] || '';

        let tooltipContent = `<b>Week:</b> ${week}<br/>`;

        this.points.forEach((point) => {
          tooltipContent += `<span style="color:${point.color}">\u25CF</span> 
          <b>${point.series.name}:</b> ${point.y}<br/>`;
        });

        return tooltipContent;
      }
    },
    series: [
      {
        name: 'Number of webinars',
        type: 'line',
        color: '#F9C890',
        data: Groupsessionbyweek.count.map((x) => parseInt(x) || 0),
        yAxis: 0,
        dataLabels: { enabled: true },
      },
      {
        name: 'Total duration (mins)',
        type: 'column',
        data: Groupsessionbyweek.duration.map((x) => parseFloat(x) || 0),
        yAxis: 1,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#F2FFF6'],
            [1, '#BEF8CC'],
          ],
        },
        pointWidth: 10,
        dataLabels: {
          enabled: true,
        },
      },
    ],

    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '1-1 Session Details, by Week',
        },
      },
    },
  };


  //red flage chart
  const [redFlagsPercentageChartOptions, setRedFlagsPercentageChartOptions] =
    useState({
      chart: {
        type: 'column', // Bar chart type
        backgroundColor: 'transparent', // Optional: set background to transparent
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [], // Initially empty, will be dynamically populated
        title: {
          text: 'Weeks',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: '% Sessions Marked as Red-Flagged',
        },
        labels: {
          format: '{value}%', // Show percentage sign
        },
      },
      legend: {
        enabled: false, // Disable the legend
      },
      series: [
        {
          name: 'Red Flag Calls',
          data: [], // Initially empty, will be dynamically populated
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
            stops: [
              [0, '#E6E4FB'], // Start color
              [1, '#B7B8F9'], // End color
            ],
          },
          pointWidth: '10',
        },
      ],
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Enable data labels
            format: '{y}%', // Display the value with a percentage symbol
            style: {
              color: '#000', // Set the text color for data labels
              fontSize: '10px', // Adjust font size
              fontWeight: 'bold', // Make text bold if needed
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: ' Session based Red Flags',
          },
        },
      },
    });

  //lf category
  const [
    lfRedFlagsByCategoryChartOptions,
    setLfRedFlagsByCategoryChartOptions,
  ] = useState({
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [], // Empty initially, will be dynamically populated with week names
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: '# of Red-Flags Raised',
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: 'bold',
          color:
            (Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color) ||
            'gray',
        },
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal', // Stack the bars
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [], // Empty initially, will be populated dynamically
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: ' Instructor Feedback',
        },
      },
    },
  });

  //assesment grading Qulaity score
  const [gradingQualityChartOptions, setGradingQualityChartOptions] = useState({
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Dynamic title can be added here
    },
    xAxis: {
      categories: [], // Will be populated dynamically
      title: {
        text: 'Assessments', // X-axis label
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: ' Avg. Score', // Y-axis label
      },
      labels: {
        format: '{value}', // Display raw score
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Average Grading Quality Score', // Series name
        data: [], // Dynamic data will be added here
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#FFF5EC'], // Start color
            [1, '#F9CB9A'], // End color
          ],
        },
        pointWidth: 10, // Adjust the bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}', // Display the value with a percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Grading Quality Score',
        },
      },
    },
  });

  //Assessment Grading Quality Score

  const [gradingScoresChartOptions, setGradingScoresChartOptions] = useState({
    chart: {
      type: 'column', // Column chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Dynamic title can be added here
    },
    xAxis: {
      categories: [], // Will be populated dynamically (weeks)
      title: {
        text: 'Weeks', // X-axis label
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Average Grading Score', // Y-axis label
      },
      labels: {
        format: '{value}', // Display raw score
      },
    },
    series: [
      {
        name: 'Average Grading Score', // Series name
        data: [], // Dynamic data will be added here
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E6E4FB'], // Start color
            [1, '#B7B8F9'], // End color
          ],
        },
        pointWidth: 10, // Adjust the bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}', // Display the value with a percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Weekly Grading Scores Overview',
        },
      },
    },
  });

  const [unitcompletion, setUnitCompletion] = useState({
    new: '0%',
    returning: '0%',
    total: '0%',
  });
  //unit completion
  const clusteredColumnChartOptionsForUnitCompletion = {
    chart: {
      type: 'column', // Use 'column' for grouped bars
      backgroundColor: 'transparent', // Transparent background
    },
    title: {
      text: null, // No chart title
    },
    xAxis: {
      categories: ['New Students', 'Returning Students', 'All Students'], // Categories for the grouped columns
      title: {
        text: null, // No title for the X-axis
      },
      crosshair: true, // Enable crosshair for better readability
    },
    yAxis: {
      min: 0,
      max: 100, // Percentage scale from 0 to 100
      tickInterval: 20, // Adjust tick interval as needed
      title: {
        text: 'Completion Rate (%)', // Y-axis title as percentage
      },

      labels: {
        formatter: function () {
          return this.value + '%'; // Format labels as percentage
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    plotOptions: {
      column: {
        grouping: true, // Group the columns together by category
        borderWidth: 0, // No borders around columns
        pointWidth: 10, // Width of the columns
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Label text color
          style: {
            fontSize: '10px', // Label font size
            fontWeight: 'bold', // Bold text for labels
          },
          verticalAlign: 'middle', // Vertically align labels in the middle
          align: 'left', // Align labels to the left of the bars
          crop: false, // Ensure labels are visible even if they overflow
          overflow: 'none', // Do not hide labels that overflow
          x: 10,
          formatter: function () {
            return this.y + '%'; // Append % symbol to the label
          }, // Offset the labels slightly to the right
        },
      },
    },
    series: [
      {
        name: 'Unit Completion Rate ', // Series name
        colorByPoint: true, // Color each column differently
        data: [
          {
            y: parseInt(unitcompletion.new) || 0, // New students' completion rate
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#F9C78D '],
                [0.5, '#FFE9D7'],
                [1, ' #FFF3E7'],
              ],
            },
          },
          {
            y: parseInt(unitcompletion.returning) || 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [0.5, '#CEDDFA'],
                [1, '#F2F5FC'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(unitcompletion.total) || 0, // Total students

            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, ' #FF9B9B'],
                [0.5, '#FDD8D8'],
                [1, '#FDE9EB'],
              ],
            },
            pointPadding: 0.1,
          },
        ],
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts branding
    },
    exporting: {
      enabled: true, // Enable exporting options
      chartOptions: {
        title: {
          text: 'Unit Completion Rate ', // Title for the exported chart
        },
      },
    },
  };
  //call Quality score by milestone
  const [callQualityChartOptions, setCallQualityChartOptions] = useState({
    chart: {
      type: 'column', // Column chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Static title, can be updated dynamically
    },
    xAxis: {
      categories: [], // Will be populated dynamically (milestones)
      title: {
        text: 'Week', // X-axis label
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Avg. Quality Score ', // Y-axis label
      },
      labels: {
        format: '{value}', // Display raw score without percentage
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Average Call Quality Score', // Series name
        data: [], // Will be populated dynamically (call quality percentages)
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E6E4FB'], // Start color
            [1, '#B7B8F9'], // End color
          ],
        },
        pointWidth: 10, // Adjust bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}', // Display the value with a percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '1-1 Session Quality Score',
        },
      },
    },
  });

  //student satishfaction
  const [studentSatisfactionChartOptions, setStudentSatisfactionChartOptions] =
    useState({
      chart: {
        type: 'column', // Column chart type
        backgroundColor: 'transparent', // Set background to transparent
      },
      title: {
        text: '', // Static title
      },
      xAxis: {
        categories: [], // Will be populated dynamically (weeks)
        title: {
          text: '', // X-axis label
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: ' Average Satisfaction Score', // Y-axis label
        },
        labels: {
          format: '{value}', // Display raw count values (not percentage)
        },
      },
      legend: {
        enabled: false, // Disable the legend
      },
      series: [
        {
          name: 'Mid-Term Satisfaction', // Series for Mid-Term satisfaction
          data: [], // Will be populated dynamically
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#F9C78D'],
              [0.5, '#FFE9D7'],
              [1, '#FFF3E7'],
            ],
          },
          pointPadding: 0.1,
          pointWidth: 10, // Adjust bar width if necessary
          dataLabels: {
            enabled: true, // Enable data labels
            formatter: function () {
              return this.y + '%'; // Show the value with a % symbol
            },
            style: {
              fontSize: '12px', // Customize the font size
              fontWeight: 'bold', // Customize the font weight
              color: 'black', // Customize the font color
            },
          },
        },
        {
          name: 'End-Term Satisfaction', // Series for End-Term satisfaction
          data: [], // Will be populated dynamically
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#A2CCFA'],
              [0.5, '#CEDDFA'],
              [1, '#F2F5FC'],
            ],
          },
          pointPadding: 0.1,
          pointWidth: 10,
          dataLabels: {
            enabled: true, // Enable data labels
            formatter: function () {
              return this.y + '%'; // Show the value with a % symbol
            },
            style: {
              fontSize: '12px', // Customize the font size
              fontWeight: 'bold', // Customize the font weight
              color: 'black', // Customize the font color
            },
          },
        },
      ],
      credits: {
        enabled: false, // Disable Highcharts branding
      },
      exporting: {
        enabled: true, // Enable exporting options
        chartOptions: {
          title: {
            text: 'Student Satisfaction by Week', // Title for the exported chart
          },
        },
      },
    });

  //Message Responsiveness
  const donutChartOptions1 = {
    chart: {
      type: 'pie', // Change to pie for donut chart
      backgroundColor: 'transparent', // Optional: set background to transparent
      options3d: {
        enabled: true, // Enable 3D for donut effect
        alpha: 45, // Set the alpha angle for the 3D view
        beta: 0, // Beta angle
      },
    },
    title: {
      text: '', // Removed the title
    },
    tooltip: {
      pointFormat: '{point.name}: <b>{point.y}%</b>', // Customize tooltip to include percentage
    },

    plotOptions: {
      pie: {
        innerSize: '90%', // Increase inner size to reduce the thickness of the donut
        dataLabels: {
          enabled: false,
          formatter: function () {
            // Only render labels for the first point to avoid duplication
            if (this.point.index === 0) {
              return this.series.data
                .map((point) => `${point.name}: ${point.y}%`)
                .join('<br>');
            }
            return null; // Skip for other points
          },
          style: {
            fontWeight: 'bold',
            color: 'black',
            textAlign: 'center',
          },
          distance: -150, // Increase space between labels and the chart
          connectorWidth: 1, // Draw a line connecting labels to chart
          crop: false, // Prevent labels from being cropped
          // overflow: "allow", // Allow labels to overflow outside the chart
        },
        size: '80%',
        startAngle: -90, // Start angle for semi-circle
        endAngle: 90, // End angle for semi-circle
        center: ['50%', '75%'], // Center of the pie chart
        borderWidth: 0, // No border
      },
    },
    series: [
      {
        name: 'Message Responsiveness',
        data: [
          {
            name: 'Within 60 min',
            y: metricsData?.messageResponsiveness['0-1hrs']
              ? parseFloat(metricsData.messageResponsiveness['0-1hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
              stops: [
                [0, '#EBFFEE'],
                [1, '#A2EAB3'],
              ],
            },
          },
          {
            name: 'In 1-2 hrs',
            y: metricsData?.messageResponsiveness['1-2hrs']
              ? parseFloat(metricsData.messageResponsiveness['1-2hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, '#e6eeff'],
                [1, '#B7D0F6'],
              ],
            },
          },
          // {
          //   name: 'In 2-4 hrs',
          //   y: metricsData?.messageResponsiveness["2-4hrs"] ? parseInt(metricsData.messageResponsiveness["2-4hrs"]) : 0,
          //   color: {
          //     linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
          //     stops: [
          //       [0, '#FFEFE1'],
          //       [1, '#FFE5CD'],
          //     ],
          //   },
          // },
          {
            name: 'In 2-6 hrs',
            y: metricsData?.messageResponsiveness['2-6hrs']
              ? parseFloat(metricsData.messageResponsiveness['2-6hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [1, '#F2F5FC'],
              ],
            },
          },
          {
            name: 'In More than 6 hrs',
            y: metricsData?.messageResponsiveness['above_6_hrs']
              ? parseFloat(metricsData.messageResponsiveness['above_6_hrs'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
              stops: [
                [0, '#E6EEFF'],
                [1, '#9397FF'],
              ],
            },
          },
          {
            name: 'Not Responded',
            y: metricsData?.messageResponsiveness['not_responded']
              ? parseFloat(metricsData.messageResponsiveness['not_responded'])
              : 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, '#FFD2D2'],
                [1, '#F79496'],
              ],
            },
          },
        ],
      },
    ],
    legend: {
      enabled: false, // Optionally disable the legend if it's not needed
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Message Responsiveness (%)', // Removed title from exporting options
        },
      },
    },
  };
  //Topics Discussed week on week
  const [topicsBarChart, setTopicsBarChart] = useState({
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [], // Weeks will be dynamically populated
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Topics',
      },
      labels: {
        format: '{value}', // Display topics
      },
    },
    series: [
      {
        name: 'Topics Discussed (week on week)',
        data: [], // Data will be dynamically populated
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
          stops: [
            [0, '#E6E4FB'], // Start color
            [1, '#B7B8F9'], // End color
          ],
        },
        pointWidth: '10',
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}', // Display the value with a percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Topics Discussed (Week on Week)', // Title for exporting
        },
      },
    },
  });

  const teacherNames = teachersChartData ? Object.keys(teachersChartData) : [];
  const studentEngagementValues = teachersChartData
    ? Object.values(teachersChartData)
    : [];

  // Charts for teacher tab
  const studentEngagementChartOptions = {
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Chart title
    },
    xAxis: {
      categories: teacherNames, // Teachers' names as categories
      title: {
        text: '', // X-axis label
      },
    },
    yAxis: {
      min: 0, // Y-axis starts from 0
      max: 100,
      title: {
        text: '% Students Engaged', // Y-axis label
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Add % symbol to Y-axis labels
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Active Students', // Series name
        data: studentEngagementValues, // Student counts for each teacher
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient for bars
          stops: [
            [0, '#F2FFF6'], // Start color
            [1, '#BEF8CC'], // End color
          ],
        },
        pointWidth: 10, // Adjust the bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y + '%'; // Display data labels with % symbol
          }, // Enable data labels
          // Display the value without percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false, // Disable Highcharts credits
    },
    exporting: {
      enabled: true, // Enable exporting
      chartOptions: {
        title: {
          text: 'Student Engagement Till Date', // Title for exported charts
        },
      },
    },
  };

  const teacherNamesWeeks = teachersChartDataWeeks
    ? Object.keys(teachersChartDataWeeks)
    : [];
  const studentEngagementValuesWeeks = teachersChartDataWeeks
    ? Object.values(teachersChartDataWeeks)
    : [];

  const studentEngagement50WeeksChartOptions = {
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Chart title
    },
    xAxis: {
      categories: teacherNamesWeeks, // Teachers' names as categories
      title: {
        text: '', // X-axis label
      },
    },
    yAxis: {
      min: 0, // Y-axis starts from 0
      max: 100,
      title: {
        text: '% Students Engaged in 50% of Weeks or More', // Y-axis label
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Add % symbol to Y-axis labels
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    tooltip: {
      pointFormatter: function () {
        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y}%</b><br/>`;
      },
    },
    series: [
      {
        name: 'Active Students', // Series name
        data: studentEngagementValuesWeeks, // Student counts for each teacher
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient for bars
          stops: [
            [0, '#F2FFF6'], // Start color
            [1, '#BEF8CC'], // End color
          ],
        },
        pointWidth: 10, // Adjust the bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y + '%'; // Display data labels with % symbol
          }, // Enable data labels

          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false, // Disable Highcharts credits
    },
    exporting: {
      enabled: true, // Enable exporting
      chartOptions: {
        title: {
          text: 'Student Re-engagement Till Date', // Title for exported charts
        },
      },
    },
  };

  const teacherNameEnd = teachersChartDataEndTerm
    ? Object.keys(teachersChartDataEndTerm)
    : [];
  const scoreEnd = teachersChartDataEndTerm
    ? Object.values(teachersChartDataEndTerm)
    : [];
  const studentfeedbackendtermChartOptions = {
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Chart title
    },
    xAxis: {
      categories: teacherNameEnd, // Teachers' names as categories
      title: {
        text: '', // X-axis label
      },
    },
    yAxis: {
      min: 0, // Y-axis starts from 0
      title: {
        text: 'Satisfaction Score', // Y-axis label
      },
      labels: {
        format: '{value}', // No percentage symbol, as this is student count
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Active Students', // Series name
        data: scoreEnd, // Student counts for each teacher
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient for bars
          stops: [
            [0, '#F2FFF6'], // Start color
            [1, '#BEF8CC'], // End color
          ],
        },
        pointWidth: 10, // Adjust the bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}', // Display the value without percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false, // Disable Highcharts credits
    },
    exporting: {
      enabled: true, // Enable exporting
      chartOptions: {
        title: {
          text: 'End-Term Student Feedback', // Title for exported charts
        },
      },
    },
  };
  const teachernamemidterm = teachersChartDataMidTerm
    ? Object.keys(teachersChartDataMidTerm)
    : [];
  const scoreMidterm = teachersChartDataMidTerm
    ? Object.values(teachersChartDataMidTerm)
    : [];
  const studentfeedbackmidtermChartOptions = {
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Chart title
    },
    xAxis: {
      categories: teachernamemidterm, // Teachers' names as categories
      title: {
        text: '', // X-axis label
      },
    },
    yAxis: {
      min: 0, // Y-axis starts from 0
      title: {
        text: 'Satisfaction Score', // Y-axis label
      },
      labels: {
        format: '{value}', // No percentage symbol, as this is student count
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Active Students', // Series name
        data: scoreMidterm, // Student counts for each teacher
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient for bars
          stops: [
            [0, '#F2FFF6'], // Start color
            [1, '#BEF8CC'], // End color
          ],
        },
        pointWidth: 10, // Adjust the bar width if necessary
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}', // Display the value without percentage symbol
          style: {
            color: '#000', // Set the text color for data labels
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false, // Disable Highcharts credits
    },
    exporting: {
      enabled: true, // Enable exporting
      chartOptions: {
        title: {
          text: 'Student Feed back Mid Term', // Title for exported charts
        },
      },
    },
  };
  // Helper function to get a color for each category
  // const getColorForCategory = (category) => {
  //   switch (category) {
  //     case "0-1hrs":
  //       return "#FFCDD2";
  //     case "1-2hrs":
  //       return "#F8BBD0";
  //     case "2-6hrs":
  //       return "#E1BEE7";
  //     case "above_6_hrs":
  //       return "#D1C4E9";
  //     case "Not_Responded":
  //       return "#ecaba6";
  //     default:
  //       return "#000000"; // Default color
  //   }
  // };

  const getColorForCategory = (category) => {
    switch (category) {
      case '0-1hrs':
        return '#A2EAB3'; // Lighter red
      case '1-2hrs':
        return '#B7D0F6'; // Lighter pink
      case '2-6hrs':
        return '#53839299'; // Lighter purple
      case 'above_6_hrs':
        return '#9397FF'; // Lighter lavender
      case 'Not_Responded':
        return '#F79496'; // Lighter peach
      default:
        return '#CCCCCC'; // Light gray for default case
    }
  };


  // Prepare the series data for each time category
  const timeCategories = [
    '0-1hrs',
    '1-2hrs',
    '2-6hrs',
    'above_6_hrs',
    'Not_Responded',
  ];
  const seriesData = timeCategories.map((timeCategory) => {
    return teacherNames.map((teacher) => {
      const percentage = Responsiveness[teacher][timeCategory];
      return parseFloat(percentage); // Convert percentage strings to numbers
    });
  });

  // Chart configuration using the dynamic data
  const responsivenesschartinteacher = {
    chart: {
      type: 'column', // Column chart type
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: '', // Chart title
    },
    xAxis: {
      categories: teacherNames, // Teacher names as categories
      title: {
        text: '', // X-axis label
      },
    },
    yAxis: {
      min: 0, // Start Y-axis from 0
      max: 100, // Max value for percentage
      title: {
        text: 'Time Taken', // Y-axis label
      },
      labels: {
        format: '{value}%', // Percentage format for labels
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: timeCategories.map((timeCategory, index) => ({
      name: timeCategory,
      data: seriesData[index], // Get the corresponding series data
      color: getColorForCategory(timeCategory), // Use a helper function to get a color
    })),
    plotOptions: {
      column: {
        pointWidth: 10, // Set bar width
        stacking: 'percent', // Stack values to show percentages
        dataLabels: {
          enabled: false,
          format: '{series.name}: {point.y}%', // Display series name and percentage value
          style: {
            color: '#000', // Set text color
            fontSize: '10px', // Adjust font size
            fontWeight: 'bold', // Make text bold if needed
          },
        },
      },
    },
    credits: {
      enabled: false, // Disable Highcharts credits
    },
    exporting: {
      enabled: true, // Enable exporting
      chartOptions: {
        title: {
          text: 'Message Responsiveness Till Date', // Title for exported charts
        },
      },
    },
  };


  const chartRef = useRef();
  const chartOptions = {
    chart: {
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: timeCommitedData ? timeCommitedData.teachers : [],
      title: {
        text: '',
      },
    },
    yAxis: [
      {
        title: {
          text: 'Messages / Sessions',
        },
        labels: {
          format: '{value}',
        },
      },
      {
        title: {
          text: 'Session Duration (Hours)',
        },
        opposite: true,
        labels: {
          format: '{value}',
        },
      },
    ],
    series: [
      {
        type: 'column',
        name: '1-1 Session Duration (Hrs)',
        yAxis: 1,
        data: timeCommitedData ? timeCommitedData.conversations : [0],
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#FFCDD2'],
            [1, '#F8BBD0'],
          ],
        },
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          format: '{y}',
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
        events: {
          legendItemClick: function () {
            const chart = chartRef.current.chart;
            const yAxisIndex = this.yAxis.options.index || 1;
            const yAxis = chart.yAxis[yAxisIndex];
            const willHide = !this.visible;
            setTimeout(() => {
              yAxis.update({
                min: 0,

                visible: !willHide,
                title: { text: !willHide ? '1-1 Session Duration (Hrs)' : null },
              });
            }, 0);
          },
        },
      },
      {
        type: 'line',
        name: 'Total Messages Sent',
        yAxis: 0,
        data: timeCommitedData ? timeCommitedData.sentMessages : [0],
        color: '#a9eb91',
        marker: {
          enabled: true,
          symbol: 'circle',
          radius: 4,
        },
        lineWidth: 2,
        dataLabels: {
          enabled: true,
          format: '{y}',
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
        events: {
          legendItemClick: function () {
            const chart = chartRef.current.chart;

            // delay the update to reflect upcoming visibility state
            setTimeout(() => {
              const sentSeries = chart.series.find(
                (s) => s.name === 'Total Messages Sent',
              );
              const sessionSeries = chart.series.find(
                (s) => s.name === 'Number of 1-1 Sessions',
              );
              const yAxis = chart.yAxis[0];

              const sentVisible = sentSeries && sentSeries.visible;
              const sessionVisible = sessionSeries && sessionSeries.visible;

              let newTitle = null;
              if (sentVisible && sessionVisible) {
                newTitle = 'Messages / Sessions';
              } else if (sentVisible) {
                newTitle = 'Total Messages Sent';
              } else if (sessionVisible) {
                newTitle = 'Number of 1-1 Sessions';
              }

              yAxis.update({
                min: 0,
                title: { text: newTitle },
              });
            }, 0);

            // allow default toggle behavior
            return true;
          },
        },
      },
      {
        type: 'line',
        name: 'Number of 1-1 Sessions',
        yAxis: 0,
        data: timeCommitedData ? timeCommitedData.totalcalls : [0],
        color: '#f2c446',
        marker: {
          enabled: true,
          symbol: 'diamond',
          radius: 4,
        },
        lineWidth: 2,
        dataLabels: {
          enabled: true,
          format: '{y}',
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
        events: {
          legendItemClick: function () {
            const chart = chartRef.current.chart;

            // delay the update to reflect upcoming visibility state
            setTimeout(() => {
              const sentSeries = chart.series.find(
                (s) => s.name === 'Total Sent Messages',
              );
              const sessionSeries = chart.series.find(
                (s) => s.name === 'Number of 1-1 Sessions',
              );
              const yAxis = chart.yAxis[0];

              const sentVisible = sentSeries && sentSeries.visible;
              const sessionVisible = sessionSeries && sessionSeries.visible;

              let newTitle = null;
              if (sentVisible && sessionVisible) {
                newTitle = 'Messages / Sessions';
              } else if (sentVisible) {
                newTitle = 'Total Sent Messages';
              } else if (sessionVisible) {
                newTitle = 'Number of Sessions';
              }

              yAxis.update({
                min: 0,

                title: { text: newTitle },
              });
            }, 0);

            // allow default toggle behavior
            return true;
          },
        },
      },
    ],

    plotOptions: {
      column: {
        grouping: false,
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Student Engagement Activity',
        },
      },
    },
  };

  //group session by teacher 
  const groupSessionsByTeachersChartConfig = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: teacherNameCategories, // Teacher names
      title: {
        text: '',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Group Sessions',
      },
      labels: {
        formatter: function () {
          return this.value; // No percentage
        },
      },
    },
    legend: {
      enabled: true, // ✅ Enable legend
      align: 'center', // can be 'left', 'center', 'right'
      verticalAlign: 'bottom', // can be 'top', 'middle', 'bottom'
      layout: 'horizontal', // 'vertical' or 'horizontal'
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '12px',
        color: '#000',
      },
    },
    series: [
      {
        name: 'Group Sessions Count',
        data: engagementPercentageValues, // Raw counts here
        pointWidth: 10,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E1EAF9'],
            [1, '#A5C7FA'],
          ],
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y; // Display count only
          },
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
      },
    ],
    credits: { enabled: false },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Group Sessions by Teachers',
        },
      },
    },
  };

  //teacherfroupsession and oneto one session chart
  const [sessionQualityByTeacher, setSessionQualityByTeacher] = useState({
    teachers: [],
    one_on_one_scores: [],
    group_session_scores: [],
  });

  const sessionQualityScoreChart = {
    chart: {
      type: 'line',
      backgroundColor: 'transparent',
    },
    title: { text: '' },
    xAxis: {
      categories: sessionQualityByTeacher.teachers || [],
      title: { text: '' },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: { text: 'Avg. Quality Score' },
    },
    series: [
      {
        name: '1-1 Sessions',
        data: sessionQualityByTeacher.one_on_one_scores || [],
        color: '#F4B3BF',
        marker: { enabled: true },
      },
      {
        name: 'Group Sessions',
        data: sessionQualityByTeacher.group_session_scores || [],
        color: '#95B0F6',
        marker: { enabled: true },
      },
    ],
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y; // show score number
          },
          style: {
            color: '#000',
            fontSize: '10px',
          },
        },
      },
    },
    credits: { enabled: false },
    exporting: {
      enabled: true,
      chartOptions: {
        title: { text: 'Session Quality Score' },
      },
    },
  };
  //grading quality score by teacher
  const gradingQualityChartOptionsbyteacher = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: { text: '' },
    xAxis: {
      categories: gradingTeacherNamesbyteacher,
    },

    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Avg Grading Quality Score',
      },
      labels: {
        formatter() {
          return this.value + '%';
        }
      }
    },

    series: [
      {
        name: 'Grading Quality Score',
        data: gradingScoresbyTeacher, // numbers only (93.3, 93.3, 100)
        pointWidth: 10,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#FFF4F4'],
            [1, '#FFA7A7'],
          ],
        },
        dataLabels: {
          enabled: true,
          formatter() {
            return this.y + '%';  // <-- show % label
          },
        },
      },
    ],

    credits: { enabled: false },
  };


  const handleSelectMilestone = (item) => {
    handleSelectItem(
      item,
      selectedMilestones,
      setSelectedMilestones,
      toggleMilestoneDropdown,
    );
  };

  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };

  const toggleProgramDropdown = () => {
    setProgramDropdownOpen((prev) => !prev);
  };
  const toggleMilestoneDropdown = () =>
    setMilestoneDropdownOpen((prev) => !prev);

  const toggleMilestonetypeDropdown = () =>
    setMilestonetypeDropdownOpen((prev) => !prev);
  // const toggleTermDropdown = (year) => {
  //   setTermDropdownOpen((prevState) => ({
  //     ...prevState,
  //     [year]: !prevState[year],
  //   }));
  // };
  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const toggleUnitDropdown = () => {
    setUnitDropdownOpen((prev) => !prev); // Toggle term dropdown
  };
  const toggleWeekDropdown = () => {
    setWeekDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const toggleTeacherDropdown = () => {
    setTeacherDropdownOpen((prev) => !prev);
  };

  const handleSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
  ) => {
    let newSelection = new Set(selectedSet);
    setResetTrigger((prev) => prev + 1);
    setpayload({});
    // If the item is part of universities or programs (which allow multiple selections), handle accordingly
    if (
      item.removename === 'removeuniversity' ||
      item.removename === 'removeprograms'
    ) {
      // If the selected item is already chosen, allow deselection
      if (selectedSet.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    } else if (
      item.removename === 'removeyears' ||
      item.removename === 'removestudyperiod' ||
      item.removename === 'removemilestone' ||
      item.removename === 'removemilestonetype' ||
      item.removename === 'removeunits' ||
      item.removename === 'removeweek'
    ) {
      // If the item is part of year or study period (single selection)
      newSelection.clear(); // Clear all previous selections
      // newSelection.delete(item.id);
      newSelection.add(item.id); // Add the new selection
    }

    // Clear dependent selections when an item is deselected
    if (item.removename === 'removeuniversity') {
      setSelectedPrograms(new Set());
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setSelectedUnits(new Set());
      setPrograms([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
      setSelectedUnits(new Set());
      setTimelineUnit([]);
      setSelectedWeeks(new Set());
      setWeeks([]);
    } else if (item.removename === 'removeprograms') {
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setSelectedUnits(new Set());
      setTimelineYears([]);
      setTimelineTerms([]);
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
      setTimelineUnit([]);
      setSelectedWeeks(new Set());
      setWeeks([]);
    } else if (item.removename === 'removeyears') {
      setSelectedTerms(new Set());
      setTimelineTerms([]);
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
      setSelectedUnits(new Set());
      setTimelineUnit([]);
      setSelectedWeeks(new Set());
      setWeeks([]);
    } else if (item.removename === 'removestudyperiod') {
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
      setSelectedUnits(new Set());
      setTimelineUnit([]);
      setSelectedWeeks(new Set());
      setWeeks([]);
    } else if (item.removename === 'removeunits') {
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);

      setSelectedWeeks(new Set());
      setWeeks([]);
    } else if (item.removename === 'removemilestonetype') {
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
      setSelectedUnits(new Set());
      setTimelineUnit([]);
      setSelectedWeeks(new Set());
      setWeeks([]);
    }

    setSelectedSet(newSelection);
    toggleDropdown();
  };
  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);
  const ismilestonetypemSelected = (selectedMiletype) =>
    selectedMilestonestype.has(selectedMiletype);
  const ismilestoneSelected = (selectedMilestone) =>
    selectedMilestones.has(selectedMilestone);

  const handleSelectItemTimeLine = (selectedYear) => {
    const newSelection = new Set(selectedTimelines);
    if (newSelection.has(selectedYear)) {
      newSelection.delete(selectedYear);
    } else {
      newSelection.add(selectedYear);
    }
    setSelectedTimelines(newSelection);
  };

  const handleSelectItemTerm = (selectedTerm) => {
    const newSelection = new Set(selectedTerms);
    if (newSelection.has(selectedTerm)) {
      newSelection.delete(selectedTerm);
    } else {
      newSelection.add(selectedTerm);
    }
    setSelectedTerms(newSelection);
  };

  const handleSelectItemunit = (selectedUnit) => {
    const newSelection = new Set(selectedUnits);
    if (newSelection.has(selectedUnit)) {
      newSelection.delete(selectedUnit);
    } else {
      newSelection.add(selectedUnit);
    }
    setSelectedUnits(newSelection);
  };
  const handleSelectTeacher = (selectedTeacher) => {
    const newSelection = new Set(selectedTeachers);
    if (newSelection.has(selectedTeacher)) {
      newSelection.delete(selectedTeacher);
    } else {
      newSelection.add(selectedTeacher);
    }
    setSelectedTeachers(newSelection);
  };

  const isTimelineSelected = (selectedYear) =>
    selectedTimelines.has(selectedYear);
  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);
  const handleunitSelectItem = (
    unit,
    selectedUnits,
    setSelectedUnits,
    toggleUnitDropdown,
  ) => {
    // Create a new Set that only contains the new selection
    const newSelectedUnits = new Set();
    newSelectedUnits.add(unit.id); // Add the new unit's ID

    // Update state to reflect the new selected unit
    setSelectedUnits(newSelectedUnits);
    toggleUnitDropdown();
  };

  // Check if a unit is selected
  const isUnitSelected = (unitId) => {
    return selectedUnits.has(unitId); // Check if unit ID is in the Set
  };
  // const isUnitSelected = (selectedUnit) => selectedUnits.has(selectedUnit);

  const isTeacherSelected = (selectedTeacher) =>
    selectedTeachers.has(selectedTeacher);

  const handleSelectItem1 = (item, selectedSet, setter, toggleDropdown) => {
    const newSelection = new Set();

    // Always add the selected item (ID) to the selection set
    newSelection.add(item.id);

    setter(newSelection); // Update the state with the new single selection
    toggleDropdown(); // Optionally toggle the dropdown visibility
  };

  const handleApply = () => {
    if (selectedUnits.size === 0) {
      toast.error('select all filters');
    }


    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedUnit(new Set(selectedUnits));
    setAppliedPrograms(new Set(selectedPrograms));
    setAppliedMilestonetype(new Set(selectedMilestonestype));
    setAppliedMilestone(new Set(selectedMilestones));
    setAppliedWeeks(new Set(selectedWeeks));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelinesiur', selectedTimelines);
    saveToSessionStorage('appliedTermsiur', selectedTerms);
    saveToSessionStorage('appliedPrograms', selectedPrograms);
    saveToSessionStorage('appliedWeeksiur', selectedWeeks);

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('selectedTimelinesiur', selectedTimelines);
    saveToSessionStorage('appliedPrograms', selectedPrograms);
    saveToSessionStorage('selectedTermsiur', selectedTerms);
    saveToSessionStorage('selectedWeeksiur', selectedWeeks);

    saveToSessionStorage('appliedmilestoetypeiur', selectedMilestonestype);
    saveToSessionStorage('appliedmilestoeiur', selectedMilestones);
    saveToSessionStorage('selectedmilestonetypeiur', selectedMilestonestype);
    saveToSessionStorage('selectedmilestoneiur', selectedMilestones);
    saveToSessionStorage('appliedunitiur', selectedUnits);
    saveToSessionStorage('selecetdunitiur', selectedUnits);

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setUnitDropdownOpen(false);
  };

  const handleNaviagteTd = () => {
    navigate('/individalunitreport/teacherdeployed');
  };
  const handleNavigatestudSupported = () => {
    navigate('/individalunitreport/studentsupported');
  };

  const columns = [
    { field: 'sno', headerName: 'S.no', width: 100 },
    { field: 'teachername', headerName: 'Teacher Name', width: 300 },
    { field: 'tstud', headerName: 'Number of student', width: 280 },
    { field: 'tduration', headerName: 'Total duration', width: 250 },
    { field: 'avgweek', headerName: 'Avg. weekly engagement', width: 250 },
    {
      field: 'avgdurstud',
      headerName: 'Avg. duration(per student)',
      width: 250,
    },
    { field: 'tsms', headerName: 'Total Message', width: 250 },
  ];

  const handleRowClick = (rowData) => {
    // Navigate to the desired page without passing in the URL
    navigate('/individalunitreport/unitstuddetails', {
      state: { studentID: rowData.id },
    });
  };
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const fetchDataTabs = async () => {
    try {
      const payload = {
        mode: 'tabs',
        // user_id: parseInt(uid)
      };

      // console.log('Sending tabs request with token:', user_token); // 🔍
      // console.log('Payload:', payload);

      const tabResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        },
      );
      localStorage.setItem('tabs', JSON.stringify(tabResponse.data));

      // console.log('Tabs Response:', tabResponse);
    } catch (error) {
      // console.log('Error fetching tab data:', error);
    }
  };

  useEffect(() => {
    fetchDataTabs();
  }, []);
  const fetchData = async () => {
    try {
      setLoadingFilters(true);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingFilters(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataPrograms();
    }
  }, [selectedUniversities]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);
  const fetchDataPrograms = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
        // milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setPrograms(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'metrics',
        sub_mode: 'year',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedTimelines]);

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'teacher_report',
        sub_mode: 'term',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0
    ) {
      fetchDatawithYearUnit();
    }
    // fetchDatawithYearUnit();
  }, [selectedTerms]);
  const fetchDatawithYearUnit = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,

        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        milestone_type:
          selectedMilestonestype.size > 0
            ? Array.from(selectedMilestonestype)[0]
            : null,
        milestone_number:
          selectedMilestones.size > 0
            ? Array.from(selectedMilestones)[0]
            : null,
        mode: 'teacher_report',
        sub_mode: 'unit',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineUnit(unitResponse.units || []);
      setTimelineUnit(
        payload.university || payload.year || payload.term
          ? unitResponse.units || []
          : unitResponse.all_units || [],
      );
    } catch (error) { }
  };

  //weeks filter

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedUnits.size > 0
    ) {
      fetchDataWeeks();
    }
  }, [selectedUnits]);
  const fetchDataWeeks = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,

        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        // milestone_type: selectedMilestonestype.size > 0 ? Array.from(selectedMilestonestype)[0] : null,
        // milestone_number: selectedMilestones.size > 0 ? Array.from(selectedMilestones)[0] : null,
        mode: 'individual_unit_report',
        sub_mode: 'weeks',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineUnit(unitResponse.units || []);
      // setTimelineUnit(
      //   payload.university || payload.year || payload.term
      //     ? unitResponse.units || []
      //     : unitResponse.all_units || []
      // );
      setWeeks(unitResponse.weeks || []);
    } catch (error) { }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0
    ) {
      fetchDataMileStonetype();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  const fetchDataMileStonetype = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,

        mode: 'teacher_qc',
        sub_mode: 'milestone_type',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestonetype(unitResponse.milestone_types || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedMilestonestype.size > 0
    ) {
      fetchDataMileStone();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
    selectedMilestonestype,
  ]);

  const fetchDataMileStone = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        milestone_type:
          selectedMilestonestype.size > 0
            ? Array.from(selectedMilestonestype)[0]
            : null,

        mode: 'teacher_qc',
        sub_mode: 'milestone',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestone(unitResponse.milestone || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  //refresh data for 500 error
  const resetData = () => {
    setResetTrigger((prev) => prev + 1);
    setpayload({});
    setCardsData(null);
    SetInsightsQuestions(null);
    setwebinar_performance_response(null);
    setwebinarAverageChartsDataProps(null);
    setCall_performance_response(null);
    setInsightsData(null);
    SetInsightsTopics(null);
    SetStudentList(null);
    SetTeacherTableData(null);
    setStudenageChart({});
    setCensusdropChart({});
    setUnitCompletion({});
    setStudentReengagementChart(null);
    SetphonevideoEngagedchart({
      weeks: [],
      phone_video_engaged: [],
      student_engaged_one_one: [],
    });

    setAvertimeperstudchart({
      weeks: [],
      average_time_per_call: [],
      average_time_per_student: [],
    });

    setWeekOnweekmsgCallChart({
      weeks: [],
      total_received_mail: [],
      total_received_sms: [],
      total_sent_mail: [],
      total_sent_sms: [],
    });
    setMetricsData(null);

    setRedFlagsPercentageChartOptions({
      chart: {
        type: 'column', // Bar chart type
        backgroundColor: 'transparent', // Optional: set background to transparent
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [], // Initially empty, will be dynamically populated
        title: {
          text: 'Weeks',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Percentage of Red Flag Calls (%)',
        },
        labels: {
          format: '{value}%', // Show percentage sign
        },
      },
      series: [
        {
          name: 'Red Flag Calls',
          data: [], // Initially empty, will be dynamically populated
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
            stops: [
              [0, '#E6E4FB'], // Start color
              [1, '#B7B8F9'], // End color
            ],
          },
          pointWidth: '10',
        },
      ],
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Enable data labels
            format: '{y}%', // Display the value with a percentage symbol
            style: {
              color: '#000', // Set the text color for data labels
              fontSize: '10px', // Adjust font size
              fontWeight: 'bold', // Make text bold if needed
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: ' Session based Red Flags',
          },
        },
      },
    });

    setLfRedFlagsByCategoryChartOptions({
      chart: {
        type: 'column', // Bar chart type
        backgroundColor: 'transparent', // Optional: set background to transparent
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [], // Empty initially, will be dynamically populated with week names
        title: {
          text: 'Weeks',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Red Flags',
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color:
              (Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              'gray',
          },
        },
      },
      plotOptions: {
        column: {
          stacking: 'normal', // Stack the bars
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [], // Empty initially, will be populated dynamically
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: ' Instructor Feedback',
          },
        },
      },
    });

    SetcallDetailsOverchart({
      weekscallback: [],
      no_of_phone_calls: [],
      total_duration: [],
      total_duration_str: [],
    });

    setCallQualityChartOptions({
      chart: {
        type: 'column', // Column chart type
        backgroundColor: 'transparent', // Optional: set background to transparent
      },
      title: {
        text: '', // Static title, can be updated dynamically
      },
      xAxis: {
        categories: [], // Will be populated dynamically (milestones)
        title: {
          text: 'Week', // X-axis label
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Average Call Quality Score', // Y-axis label
        },
        labels: {
          format: '{value}', // Display raw score without percentage
        },
      },
      series: [
        {
          name: 'Average Call Quality Score', // Series name
          data: [], // Will be populated dynamically (call quality percentages)
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
            stops: [
              [0, '#E6E4FB'], // Start color
              [1, '#B7B8F9'], // End color
            ],
          },
          pointWidth: 10, // Adjust bar width if necessary
        },
      ],
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Enable data labels
            format: '{y}', // Display the value with a percentage symbol
            style: {
              color: '#000', // Set the text color for data labels
              fontSize: '10px', // Adjust font size
              fontWeight: 'bold', // Make text bold if needed
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: 'Average Call Quality Score by Milestone',
          },
        },
      },
    });

    setGradingQualityChartOptions({
      chart: {
        type: 'column', // Bar chart type
        backgroundColor: 'transparent', // Optional: set background to transparent
      },
      title: {
        text: '', // Dynamic title can be added here
      },
      xAxis: {
        categories: [], // Will be populated dynamically
        title: {
          text: 'Assessments', // X-axis label
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Average Grading Quality Score', // Y-axis label
        },
        labels: {
          format: '{value}', // Display raw score
        },
      },
      series: [
        {
          name: 'Average Grading Quality Score', // Series name
          data: [], // Dynamic data will be added here
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
            stops: [
              [0, '#FFF5EC'], // Start color
              [1, '#F9CB9A'], // End color
            ],
          },
          pointWidth: 10, // Adjust the bar width if necessary
        },
      ],
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Enable data labels
            format: '{y}', // Display the value with a percentage symbol
            style: {
              color: '#000', // Set the text color for data labels
              fontSize: '10px', // Adjust font size
              fontWeight: 'bold', // Make text bold if needed
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: 'Average Grading Quality Score by Assessment',
          },
        },
      },
    });

    setassessstudHealthchart({
      weeks: [],
      Extremely_behind_the_track: [],
      Slightly_behind_the_track: [],
      On_track: [],
      Not_available: [],
    });
    SetassessmentDiscussionChart({
      weeks: [],
      discussing_students_percentage: [],
    });

    setGroupsessionbyweek({
      weeks: [],
      duration: [],
      count: [],
    });

    setGroupsessionQualitycorce((prev) => ({
      ...prev,
      xAxis: { ...prev.xAxis, categories: [] },
      series: [{ ...prev.series[0], data: [] }],
    }));

    setOneToOneChart((prev) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: [],
        },
        {
          ...prev.series[1],
          data: [],
        },
      ],
    }));
    setSessionQualityByTeacher({
      teachers: [],
      one_on_one_scores: [],
      group_session_scores: [],
    });
    setGradingTeacherNames([]);
    setGradingScores([]);
    setTeacherNameCategories([]);
    setEngagementPercentageValues([]);
    // teacher tab
    setTeachersChartData();
    setTeachersChartDataMidTerm();
    setTeachersChartDataEndTerm();
    setTeachersChartDataWeeks();
    setTimeCommitedData();
    setResponsiveness();
  };

  const [payload, setpayload] = useState({});

  const fetchDataTeacher = async () => {
    // console.log(appliedUnit);
    const payload = {
      university:
        (appliedUniversities.size > 0
          ? Array.from(appliedUniversities)
          : null) ||
        (Deatilsofunits?.appliedUniversities?.size > 0
          ? Array.from(Deatilsofunits.appliedUniversities)
          : null),
      year:
        (appliedTimelines.size > 0 ? Array.from(appliedTimelines) : null) ||
        (Deatilsofunits?.appliedTimelines?.size > 0
          ? Array.from(Deatilsofunits.appliedTimelines)
          : null),
      term:
        (appliedTerms.size > 0 ? Array.from(appliedTerms) : null) ||
        (Deatilsofunits?.appliedTerms?.size > 0
          ? Array.from(Deatilsofunits.appliedTerms)
          : null),
      unit:
        (appliedUnit.size > 0 ? parseInt(Array.from(appliedUnit)[0]) : null) ||
        Deatilsofunits?.unit_id,
      program:
        (appliedPrograms && appliedPrograms.size > 0
          ? Array.from(appliedPrograms)
          : null) ||
        (Deatilsofunits?.appliedPrograms?.size > 0
          ? Array.from(Deatilsofunits.appliedPrograms)
          : null),
      milestone_type:
        (appliedmilestonetype.size > 0
          ? Array.from(appliedmilestonetype)[0]
          : null) ||
        (Deatilsofunits?.appliedmilestonetype?.size > 0
          ? Array.from(Deatilsofunits.appliedmilestonetype)[0]
          : null),
      weeks: appliedWeeks.size > 0 ? Array.from(appliedWeeks) : null,
      milestone_number:
        (appliedmilestone.size > 0 ? Array.from(appliedmilestone) : null) ||
        (Deatilsofunits?.appliedmilestonetype?.size > 0
          ? Array.from(Deatilsofunits.appliedmilestone)
          : null),
    };
    setpayload(payload);
    try {
      const hasMilestoneData = selectedWeeks.size > 0;
      const hasOtherFilters =
        appliedUniversities.size > 0 ||
        appliedTimelines.size > 0 ||
        appliedTerms.size > 0 ||
        appliedPrograms.size > 0;

      if (!hasMilestoneData && !hasOtherFilters) {
        return; // Exit early if all filters are empty
      }

      // Set loaders based on conditions
      if (hasMilestoneData) {
        setLoading1(true); // Show screen loader if milestone data exists
      }

      if (!hasMilestoneData && hasOtherFilters) {
        setIsApiLoading(true); // Show table loader only if milestone is empty
      }
      const config = {
        headers: {
          Authorization: `Token ${user_token}`,
        },
      };
      const [
        response,
        call_performance_response,
        webinar_performance_response,
      ] = await Promise.all([
        axios.post(
          process.env.REACT_APP_API_BASE_URL + 'individual_unit_report/',
          payload,
          config
        ),
        axios.post(
          process.env.REACT_APP_API_BASE_URL + 'individual_unit_report/',
          { ...payload, mode: 'call_performance' },config
        ),
        axios.post(
          process.env.REACT_APP_API_BASE_URL + 'individual_unit_report/',
          { ...payload, mode: 'webinar_performance' },config
        ),
      ]);

      // const response = await axios.post(
      //   process.env.REACT_APP_API_BASE_URL + 'individual_unit_report/',
      //   payload,
      // );
      // // console.log({ response, call_performance_response });
      setCall_performance_response(call_performance_response);
      setwebinar_performance_response(webinar_performance_response);
      console.warn(webinar_performance_response);

      SettableData(response.data[0]?.weekly_topics_and_issues);

      //topics discussed(week on week);
      const weeklyTopicData = response?.data?.[0]?.weekly_topic_data || {};
      const weeksTopics = Object.keys(weeklyTopicData); // Extract weeks (e.g., "Week 47")
      const topicsCounts = weeksTopics.map(
        (week) => Object.keys(weeklyTopicData[week]).length,
      ); // Count topics per week

      // Update the chart with dynamic data
      setTopicsBarChart((prevChart) => ({
        ...prevChart,
        xAxis: {
          ...prevChart.xAxis,
          categories: weeksTopics, // Set dynamic weeks
        },
        series: [
          {
            ...prevChart.series[0],
            data: topicsCounts, // Set dynamic topic counts
          },
        ],
      }));
      //group session by teacher 

      //messgae responsiveness
      const metrics = {
        messageResponsiveness: response?.data?.[0]
          ?.cumulative_message_responsiveness || {
          '0-1hrs': '0%',
          '1-2hrs': '0%',
          '2-4hrs': '0%',
          '4-6hrs': '0%',
          'above_6_hrs': '0%',
          'not_responded': '100%',
        },
      };

      setMetricsData(metrics);
      // Student Feedback
      const weeklySatisfactionData =
        response.data[0]?.weekly_student_satisfaction || {};

      // Extract MID and END satisfaction scores directly
      const categories = ['Mid-Term', 'End-Term'];
      const satisfactionScores = [
        weeklySatisfactionData.MID || 0,
        weeklySatisfactionData.END || 0,
      ];

      // Update chart options
      setStudentSatisfactionChartOptions((prevOptions) => ({
        ...prevOptions, // Keep other chart options intact
        xAxis: {
          ...prevOptions.xAxis,
          categories: categories, // Set categories as Mid-Term and End-Term
        },
        series: [
          {
            name: 'Satisfaction Scores', // Series name
            data: satisfactionScores, // Set satisfaction data dynamically
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, '#F9C78D'],
                [0.5, '#FFE9D7'],
                [1, '#FFF3E7'],
              ],
            },
            dataLabels: {
              enabled: true, // Enable data labels
              formatter: function () {
                return this.y.toFixed(1); // Ensure one decimal place
              },
              style: {
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#333', // Adjust label color
              },
            },
            pointPadding: 0.1,
            pointWidth: 10, // Adjust bar width if necessary
          },
        ],
      }));

      // Extract weekly call quality percentage data from response
      const weeklyCallQualityData =
        response.data[0]?.weekly_call_quality_percentage || {};
      // Dynamically update chart options based on the fetched data
      const milestones = Object.keys(weeklyCallQualityData); // Extract milestones (e.g., "Milestone 1")
      const callQualityScores = Object.values(weeklyCallQualityData); // Extract corresponding call quality scores

      setCallQualityChartOptions((prevOptions) => ({
        ...prevOptions, // Keep other chart options intact
        xAxis: {
          ...prevOptions.xAxis,
          categories: milestones, // Set the milestones dynamically
        },
        series: [
          {
            name: 'Average Call Quality Score', // Series name
            data: callQualityScores, // Set the call quality data dynamically
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#E6E4FB'], // Start color
                [1, '#B7B8F9'], // End color
              ],
            },
            pointWidth: 10, // Adjust the bar width if necessary
          },
        ],
      }));
      //Assessment Grading Quality Score
      const weeklyGradingScores =
        response.data[0]?.weekly_average_grading_score || {};

      // Dynamically update chart options
      const weekLabels = Object.keys(weeklyGradingScores); // Extract week labels (e.g., "Week 48")
      const weeklyScores = Object.values(weeklyGradingScores); // Extract corresponding grading scores

      setGradingScoresChartOptions((prevOptions) => ({
        ...prevOptions, // Spread the previous options to maintain other properties
        xAxis: {
          ...prevOptions.xAxis,
          categories: weekLabels, // Update the xAxis categories dynamically
        },
        series: [
          {
            name: 'Average Grading Score', // Series name
            data: weeklyScores, // Set the grading scores dynamically
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#E6E4FB'], // Start color
                [1, '#B7B8F9'], // End color
              ],
            },
            pointWidth: 10, // Adjust the bar width if necessary
          },
        ],
      }));

      //gradingScoreByAssessment
      const gradingScoreByAssessment =
        response.data[0]?.grading_score_by_assessment || {};
      // Dynamically update chart options
      const assessments = Object.keys(gradingScoreByAssessment); // Extract assessment names
      const scores = Object.values(gradingScoreByAssessment); // Extract corresponding grading scores

      setGradingQualityChartOptions((prevOptions) => ({
        ...prevOptions, // Spread the previous options to maintain other properties
        xAxis: {
          ...prevOptions.xAxis,
          categories: assessments, // Update the xAxis categories dynamically
        },
        series: [
          {
            name: 'Average Grading Quality Score', // Series name
            data: scores, // Set the grading scores dynamically
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#FFF5EC'], // Start color
                [1, '#F9CB9A'], // End color
              ],
            },
            pointWidth: 10, // Adjust the bar width if necessary
          },
        ],
      }));
      const redFlagsData =
        response.data[0]?.percentage_of_red_flags_weekly || {};

      // Dynamically update chart options based on the fetched data
      const weeks = Object.keys(redFlagsData); // Extract weeks dynamically
      const redFlagPercentages = Object.values(redFlagsData); // Extract percentages dynamically

      setRedFlagsPercentageChartOptions({
        ...redFlagsPercentageChartOptions, // Spread the previous chart options to maintain other properties
        xAxis: {
          ...redFlagsPercentageChartOptions.xAxis,
          categories: weeks, // Update weeks dynamically
        },
        series: [
          {
            name: 'Red Flag Calls',
            data: redFlagPercentages, // Update data dynamically
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#E6E4FB'], // Start color
                [1, '#B7B8F9'], // End color
              ],
            },
            pointWidth: '10',
          },
        ],
      });

      //Lf category

      // Extract weekly flags data from the response
      const weeklyFlagsData =
        response.data[0]?.weekly_flags_raised_by_category || {};
      const groupSessionsbyWeek =
        response.data[0]?.weekly_group_sessions || {};
      setGroupsessionbyweek({
        // weeks: groupSessionsbyWeek.weeks,
        // duration: groupSessionsbyWeek.duration,
        // count: groupSessionsbyWeek.count

        weeks: groupSessionsbyWeek.weeks || [],
        duration: groupSessionsbyWeek.duration || [],
        count: groupSessionsbyWeek.count || []

      })
      const weeklyGroupSessionScore = response.data[0]?.weekly_group_sessions_quality_score || {};
      setGroupsessionQualitycorce((prev) => ({
        ...prev,
        xAxis: {
          ...prev.xAxis,
          categories: weeklyGroupSessionScore?.weeks || [],
        },
        series: [
          {
            ...prev.series[0],
            data: weeklyGroupSessionScore?.scores?.map(x => parseFloat(x) || 0) || [],
          }
        ],
      }));


      // Rename weeks to weekList to avoid conflict with other 'weeks' variables
      const weekList = Object.keys(weeklyFlagsData);

      // Prepare an empty object to hold categories and data for each category
      const categoryData = {};

      // Loop through each week and collect data for each category
      weekList.forEach((week) => {
        weeklyFlagsData[week].forEach((flag) => {
          const category = flag.category;
          const count = flag.count;

          // Initialize category data if not already present
          if (!categoryData[category]) {
            categoryData[category] = [];
          }

          // Push the count for the current week/category
          categoryData[category].push(count);
        });
      });

      // Prepare series data for each category
      const seriesData = Object.keys(categoryData).map((category) => {
        const colors = {
          'Assessment': ['#E6F5F2', '#A2D9D6'],
          'Communication': ['#F1F6FC', '#8EBBF6'],
          'Compliance': ['#FFF2E9', '#F8C58C'],
          'Engagement': ['#FFECEE', '#FCB9B9'],
          'Grading': ['#F2D6F5', '#D58BCC'],
          'Quality': ['#F0F0F0', '#C1C1C1'],
          'Student / University Complaint': ['#FFECF3', '#FFCCE0'],
        };

        return {
          name: category,
          data: categoryData[category], // Data for each category
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
            stops: [
              [0, colors[category] ? colors[category][0] : '#E6E4FB'], // Start color
              [1, colors[category] ? colors[category][1] : '#B7B8F9'], // End color
            ],
          },
          pointWidth: 10, // Adjust point width as needed
        };
      });

      // Set the chart options dynamically
      setLfRedFlagsByCategoryChartOptions((prevOptions) => ({
        ...prevOptions, // Keep other chart options intact
        xAxis: {
          ...prevOptions.xAxis,
          categories: weekList, // Set categories (weeks)
        },
        series: seriesData, // Set the dynamically generated series data
      }));

      setCardsData(response.data[0]);
      setStudenageChart(
        response?.data[0]?.student_engaged || {
          new: '0%',
          returning: '0%',
          total: '0%',
        },
      );
      const oneToOneSession = response?.data?.[0]?.one_on_one_sessions || {};

      const audioDuration = oneToOneSession?.audio_call_time?.total_duration || 0;
      const videoDuration = oneToOneSession?.video_call_time?.total_duration || 0;

      const audioCount = oneToOneSession?.audio_call_successful_count || 0;
      const videoCount = oneToOneSession?.video_call_successful_count || 0;

      setOneToOneChart((prev) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: [audioDuration, videoDuration],
          },
          {
            ...prev.series[1],
            data: [audioCount, videoCount],
          },
        ],
      }));


      setCensusdropChart({
        new: response?.data[0]?.census_drop_rate?.new_census || '0%',
        returning: response?.data[0]?.census_drop_rate?.return_census || '0%',
        total: response?.data[0]?.census_drop_rate?.total_census || '0%',
      });
      setUnitCompletion({
        new: response?.data[0]?.unit_completion_rate?.new_unit_rate || '0%',
        returning:
          response?.data[0]?.unit_completion_rate.return_unit_rate || '0%',
        total: response?.data[0]?.unit_completion_rate?.total_unit_rate || '0%',
      });


      const weeklyData = response?.data?.[0]?.re_engagement_data;



      const weeklyData1 = response?.data?.[0]?.re_engagement_data;


      setStudentReengagementChart(weeklyData1);

      setAvertimeperstudchart({
        weeks: response?.data[0]?.average_call_per_student_and_call.weeks || [],
        average_time_per_call:
          response?.data[0]?.average_call_per_student_and_call
            .average_time_per_call || [],
        average_time_per_student:
          response?.data[0]?.average_call_per_student_and_call
            .average_time_per_student || [],
      });
      setassessstudHealthchart({
        weeks: response?.data[0]?.assessment_health.weeks || [],
        Extremely_behind_the_track:
          response?.data[0]?.assessment_health.extremely_behind_the_track || [],
        Slightly_behind_the_track:
          response?.data[0]?.assessment_health.slightly_behind_the_track || [],
        On_track: response?.data[0]?.assessment_health.on_track || [],
        Not_available: response?.data[0]?.assessment_health.not_available || [],
      });
      setWeekOnweekmsgCallChart({
        weeks: response?.data[0]?.messages_mails_send_received.weeks || [],
        total_received_mail:
          response?.data[0]?.messages_mails_send_received.received || [],
        total_received_sms:
          response?.data[0]?.messages_mails_send_received.sent || [],

      });

      const responseData = response?.data[0]?.call_details_over_week || {};

      // Extracting weeks dynamically
      const weekscallback = Object.keys(responseData);

      // Extracting values for each week
      const no_of_phone_calls = weekscallback.map(
        (week) => responseData[week]?.no_of_phone_calls || 0,
      );
      const total_duration = weekscallback.map(
        (week) => responseData[week]?.total_duration || 0,
      );
      const total_duration_str = weekscallback.map(
        (week) => responseData[week]?.total_duration_str || 0,
      );

      SetcallDetailsOverchart({
        weekscallback,
        no_of_phone_calls,
        total_duration,
        total_duration_str
      });

      SetphonevideoEngagedchart({
        weeks: response?.data[0]?.student_phone_video_engaged.weeks || [],
        phone_video_engaged:
          response?.data[0]?.student_phone_video_engaged.phone_video_engaged ||
          [],
        student_engaged_one_one:
          response?.data[0]?.student_phone_video_engaged
            .student_engaged_one_one || [],
      });
      SetassessmentDiscussionChart({
        weeks: response?.data[0]?.students_discussing_assessment.weeks || [],
        discussing_students_percentage:
          response?.data[0]?.students_discussing_assessment
            .discussing_students_percentage || [],
      });

      //teacher tab
      SetTeacherTableData(response.teachers_table_data);
      const data =
        response.teachers_chart_data.proportion_of_active_students_engaged;
      setTeachersChartData(data);
      //teacher one to one 
      const qualityData = response?.teachers_chart_data?.session_quality_by_teacher;

      if (qualityData) {
        const teachers = Object.keys(qualityData);

        const oneOnOneScores = teachers.map(
          (t) => qualityData[t]?.one_on_one_session_score || 0
        );

        const groupSessionScores = teachers.map(
          (t) => qualityData[t]?.group_session_score || 0
        );

        setSessionQualityByTeacher({
          teachers,
          one_on_one_scores: oneOnOneScores,
          group_session_scores: groupSessionScores,
        });
      } else {
        // Set empty fallback to avoid crashes
        setSessionQualityByTeacher({
          teachers: [],
          one_on_one_scores: [],
          group_session_scores: [],
        });
      }
      //grading quality by teacher 
      const gradingQualityScoreByTeacher =
        response?.teachers_chart_data?.grading_scores_by_teacher || {};
      setGradingTeacherNames(Object.keys(gradingQualityScoreByTeacher));
      setGradingScores(Object.values(gradingQualityScoreByTeacher));

      const midterm = response.teachers_chart_data.student_feedback_mid;
      setTeachersChartDataMidTerm(midterm);
      const endterm = response.teachers_chart_data.student_feedback_end;
      setTeachersChartDataEndTerm(endterm);
      const Weeks = response.teachers_chart_data.students_engaged_four_weeks;
      setTeachersChartDataWeeks(Weeks);
      // const Responsive = response.teachers_chart_data.message_responsiveness;
      // setResponsiveness(Responsive)
      // const teacherNames = Object.keys(Responsive);
      const responsivenessArray =
        response.teachers_chart_data.message_responsiveness;

      // Convert the array into an object using teacher names as keys
      const Responsiveness = {};
      responsivenessArray.forEach((teacherData) => {
        Responsiveness[teacherData.name] = teacherData;
      });

      setResponsiveness(Responsiveness);

      const teacherNames = responsivenessArray.map((teacher) => teacher.name);

      // Calculate the total response time per teacher
      const scorePercentages = teacherNames.map((teacher) => {
        const data = Responsiveness[teacher] || {}; // Ensure data exists

        const totalResponseTime =
          (parseFloat(data['0-1hrs']) || 0) +
          (parseFloat(data['1-2hrs']) || 0) +
          (parseFloat(data['2-6hrs']) || 0) +
          (parseFloat(data['above_6_hrs']) || 0) +
          (parseFloat(data['Not_Responded']) || 0); // Ensure correct key case

        return totalResponseTime;
      });
      //groupsession chart for teacher
      const groupSessionsByTeachersRaw = response?.teachers_chart_data?.group_sessions_by_teachers || {};
      const teacherNameCategories = Object.keys(groupSessionsByTeachersRaw);
      const engagementPercentageValues = Object.values(groupSessionsByTeachersRaw);
      setTeacherNameCategories(teacherNameCategories);
      setEngagementPercentageValues(engagementPercentageValues);

      const timecommited =
        response.teachers_chart_data.time_committed_engagement;

      const teachers = Object.keys(timecommited);
      const conversations = teachers.map(
        (teacher) => timecommited[teacher].total_conversation,
      );
      const sentMessages = teachers.map(
        (teacher) => timecommited[teacher].total_messages_sent,
      );
      const totalcalls = teachers.map(
        (teacher) => timecommited[teacher].total_calls,
      );

      // Store the processed data in state
      setTimeCommitedData({
        teachers,
        conversations,
        sentMessages,
        totalcalls,
      });

      //insights
      SetInsightsQuestions(response.insights.questions || []);
      SetInsightsTopics(response.insights.topics || []);
      SetStudentList(response.student_list || []);
      setInsightsData(response.insights || []);

      // Call Perfomance

      if (response.status === 500) {
        resetData();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      resetData();
    } finally {
      setLoading(false); // Set loading to false after fetching
      setIsApiLoading(false);
      setLoading1(false);
    }
  };

  const fetchDataCallPerfomance = () => { };

  useEffect(() => {
    if (
      (appliedUniversities && appliedUniversities.size > 0,
        appliedTimelines && appliedTimelines.size > 0,
        appliedTerms && appliedTerms.size > 0,
        appliedUnit && appliedUnit.size > 0)
    ) {
      fetchDataTeacher();
    }
  }, [appliedUniversities, appliedTimelines, appliedTerms, appliedUnit]);
  useEffect(() => {
    if (Deatilsofunits !== null) {
      fetchDataTeacher();
    }
  }, [Deatilsofunits]);

  // sticky filter bar

  // sticky filter bar
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to update selected filters
  const handleSelectionChange = (type, value) => {
    const updatedSet = new Set(type);
    if (updatedSet.has(value)) {
      updatedSet.delete(value);
    } else {
      updatedSet.add(value);
    }
    return updatedSet;
  };

  const [slideIndex, setSlideIndex] = useState(0);
  const slideWidth = 300; // Adjust this based on your filter tag size

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
        filterSummaryRef.current.clientWidth,
      );
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  const removeUniversity = (universityId) => {
    setSelectedUniversities((prev) => {
      const newSet = new Set(prev);
      newSet.delete(universityId);
      return newSet;
    });
  };

  // Function to remove a program from the selected set
  // const removeProgram = (programId) => {
  //   setSelectedPrograms((prev) => {
  //     const newSet = new Set(prev);
  //     newSet.delete(programId);
  //     return newSet;
  //   });
  // };

  // Function to remove a timeline from the selected set
  const removeTimeline = (year) => {
    setSelectedTimelines((prev) => {
      const newSet = new Set(prev);
      newSet.delete(year);
      return newSet;
    });
  };

  // Function to remove a term from the selected set
  const removeTerm = (term) => {
    setSelectedTerms((prev) => {
      const newSet = new Set(prev);
      newSet.delete(term);
      return newSet;
    });
  };
  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0 ||
    selectedMilestonestype.size > 0 ||
    selectedMilestones.size > 0 ||
    selectedUnits.size > 0 ||
    selectedWeeks.size > 0;

  const clearAllSelections = () => {
    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());
    setSelectedMilestonestype(new Set());
    setSelectedMilestones(new Set());
    setSelectedUnits(new Set());
    setSelectedWeeks(new Set());

    setPrograms([]);
    setTimelineYears([]);
    setTimelineTerms([]);
    setTimelineMilestone([]);
    setTimelineMilestonetype([]);
    setTimelineUnit([]);
    setAppliedWeeks([]);

    fetchData();

    removeFromSessionStorage('appliedUniversitiesiur');
    removeFromSessionStorage('appliedProgramsiur');
    removeFromSessionStorage('appliedTimelinesiur');
    removeFromSessionStorage('appliedTermsiur');
    removeFromSessionStorage('appliedmilestoetypeiur');
    removeFromSessionStorage('appliedmilestoeiur');
    removeFromSessionStorage('appliedunitiur');
    removeFromSessionStorage('selectedProgramsiur');
    removeFromSessionStorage('selectedUniversitiesiur');
    removeFromSessionStorage('selectedTimelinesiur');
    removeFromSessionStorage('selectedTermsiur');
    removeFromSessionStorage('selectedmilestonetypeiur');
    removeFromSessionStorage('selectedmilestoneiur');
    removeFromSessionStorage('selecetdunitiur');
    removeFromSessionStorage('appliedWeeksiur');
    removeFromSessionStorage('selectedWeeksiur');
    resetData();
  };
  const clearAllSelections1 = () => {
    setSelectedWeeks(new Set());
    removeFromSessionStorage('appliedWeeksiur');
    removeFromSessionStorage('selectedWeeksiur');
  };

  const { messageResponsiveness = {} } = metricsData || {};

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className={`top-flter ${isSticky ? 'sticky-filter' : ''}`}>
            <div className="">
              <div className="ind-un-re d-flex mt-1 flex-md-row flex-column  justify-content-between align-items-md-center align-items-end flex-wrap gap-2">
                <div className="d-flex  flex-wrap gap-2">
                  <Dropdown
                    isOpen={universityDropdownOpen}
                    toggle={toggleUniversityDropdown}
                  >
                    <DropdownToggle
                      className={`btn uni-bg ${universityDropdownOpen ? '' : ' '
                        }`}
                      caret
                    >
                      {loadingFilter ? 'Loading' : 'University'}{' '}
                      <i className="mdi mdi=chevron-down" />
                      {/* University <i className="mdi mdi-chevron-down" /> */}
                    </DropdownToggle>
                    {!loadingFilter && (
                      <>
                        <DropdownMenu className="p-0">
                          <input
                            type="text"
                            placeholder="Search Universities"
                            className="form-control"
                            value={universitySearch}
                            onChange={(e) =>
                              handleSearchChange(e, 'university')
                            }
                          />
                          {/* "Select All" Option */}
                          <DropdownItem
                            onClick={(e) => {
                              e.stopPropagation();
                              const allSelected =
                                selectedUniversities.size ===
                                universities.length;
                              const newSelection = new Set();

                              if (!allSelected) {
                                // Select all universities
                                universities.forEach((university) =>
                                  newSelection.add(university.id),
                                );
                                setSelectedPrograms(new Set());
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setSelectedMilestones(new Set());
                                setSelectedMilestonestype(new Set());
                                setPrograms([]);
                                setTimelineYears([]);
                                setTimelineTerms([]);
                                setTimelineMilestone([]);
                                setTimelineMilestonetype([]);
                                setSelectedWeeks(new Set());
                                setWeeks([]);
                                setSelectedUnits(new Set());
                                setTimelineUnit([]);
                              } else {
                                // Deselect all universities, applying the removeuniversity logic
                                setSelectedPrograms(new Set());
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setSelectedMilestones(new Set());
                                setSelectedMilestonestype(new Set());
                                setSelectedUnits(new Set());
                                setTimelineUnit([]);
                                setPrograms([]);
                                setTimelineYears([]);
                                setTimelineTerms([]);
                                setTimelineMilestone([]);
                                setTimelineMilestonetype([]);
                                setSelectedWeeks(new Set());
                                setWeeks([]);
                              }

                              setSelectedUniversities(newSelection); // Update the selected universities set
                              toggleUniversityDropdown(); // Close the dropdown
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  selectedUniversities.size ===
                                  universities.length
                                } // Check if all are selected
                                readOnly
                              />
                              <label className="form-check-label">All</label>
                            </div>
                          </DropdownItem>
                          {/* University Options */}
                          {/* {universities.map((university) => ( */}
                          {filterUniversities(universitySearch).map(
                            (university) => (
                              <DropdownItem
                                key={university.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(
                                    {
                                      id: university.id,
                                      name: university.university_name,
                                      removename: 'removeuniversity',
                                    },
                                    selectedUniversities,
                                    setSelectedUniversities,
                                    toggleUniversityDropdown,
                                  );
                                }}
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isItemSelected(
                                      university.id,
                                      selectedUniversities,
                                    )}
                                    readOnly
                                  />
                                  <label className="form-check-label">
                                    {university.university_name}
                                  </label>
                                </div>
                              </DropdownItem>
                            ),
                          )}
                        </DropdownMenu>
                      </>
                    )}
                  </Dropdown>

                  <Dropdown
                    isOpen={programDropdownOpen}
                    toggle={toggleProgramDropdown}
                  >
                    <DropdownToggle
                      disabled={programs.length === 0}
                      className={`btn program-bg ${programs.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Programs <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Programs"
                        className="form-control"
                        value={programSearch}
                        onChange={(e) => handleSearchChange(e, 'program')}
                      />
                      {/* All Option */}
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          const allSelected =
                            selectedPrograms.size === programs.length;
                          const newSelection = new Set();
                          if (!allSelected) {
                            programs.forEach(([programId]) =>
                              newSelection.add(programId),
                            );
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setSelectedMilestones(new Set());
                            setSelectedMilestonestype(new Set());
                            setTimelineYears([]);
                            setTimelineTerms([]);
                            setTimelineMilestone([]);
                            setTimelineMilestonetype([]);
                            setSelectedUnits(new Set());
                            setTimelineUnit([]);
                            setSelectedWeeks(new Set());
                            setWeeks([]);
                          } else {
                            //deselect
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setSelectedMilestones(new Set());
                            setSelectedMilestonestype(new Set());

                            setTimelineYears([]);
                            setTimelineTerms([]);
                            setTimelineMilestone([]);
                            setTimelineMilestonetype([]);
                          }
                          setSelectedPrograms(newSelection);
                          toggleProgramDropdown();
                        }}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedPrograms.size === programs.length}
                            readOnly
                          />
                          <label className="form-check-label">All</label>
                        </div>
                      </DropdownItem>
                      {/* {programs.map((program) => { */}
                      {/* const [programId, programName] = program;  // Destructure the ID and name from the array */}
                      {/* return ( */}
                      {filterPrograms(programSearch).map(
                        ([programId, programName]) => (
                          <DropdownItem
                            key={programId} // Use the programId as the key
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: programId,
                                  name: programName,
                                  removename: 'removeprograms',
                                },
                                selectedPrograms,
                                setSelectedPrograms,
                                toggleProgramDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isItemSelected(
                                  programId,
                                  selectedPrograms,
                                )}
                                readOnly
                              />
                              <label className="form-check-label">
                                {programName}
                              </label>
                            </div>
                          </DropdownItem>
                        ),
                      )}

                      {/* ); */}
                      {/* })} */}
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <div className="d-flex   justify-content-end flex-wrap gap-2">
                  <Dropdown
                    isOpen={timelineDropdownOpen}
                    toggle={toggleTimelineDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineYears.length === 0}
                      className={`btn year-bg ${timelineYears.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Year <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Year"
                        className="form-control"
                        value={timelineSearch}
                        onChange={(e) => handleSearchChange(e, 'timeline')}
                      />
                      {/* {timelineYears.map((year, index) => ( */}
                      {filterTimeline(timelineSearch).map((year, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: year,
                                name: year,
                                removename: 'removeyears',
                              },
                              selectedTimelines,
                              setSelectedTimelines,
                              toggleTimelineDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isItemSelected(year, selectedTimelines)}
                              readOnly
                            />
                            <label className="form-check-label">{year}</label>
                          </div>
                        </DropdownItem>
                      ))}

                      {/* // ))} */}
                    </DropdownMenu>
                  </Dropdown>

                  <Dropdown
                    isOpen={termDropdownOpen}
                    toggle={toggleTermDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineTerms.length === 0}
                      className={`btn stu-period-bg ${timelineTerms.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Study Period <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Study Period"
                        className="form-control"
                        value={termSearch}
                        onChange={(e) => handleSearchChange(e, 'term')}
                      />
                      {/* {timelineTerms.map((term, index) => ( */}
                      {filterTerms(termSearch).map((term, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: term,
                                name: term,
                                removename: 'removestudyperiod',
                              },
                              selectedTerms,
                              setSelectedTerms,
                              toggleTermDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isTermSelected(term, selectedTerms)}
                              readOnly
                            />
                            <label className="form-check-label">{term}</label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                  {/* Milestone Dropdown */}
                  {/* <Dropdown isOpen={milestonetypeDropdownOpen} toggle={toggleMilestonetypeDropdown}>
                              <DropdownToggle className={`btn mi-stone-type-bg ${timelineMilestonetype.length > 0 ? '' : ' disable'}`} caret>
                                Milestone Type <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu className="p-0"> */}
                  {/* {timelineMilestonetype.map((milestone, index) => ( */}
                  {/* Search Box */}
                  {/* <input
                                  type="text"
                                  placeholder="Search Milestone Type"
                                  className="form-control"
                                  value={milestoneTypeSearch}
                                  onChange={(e) => handleSearchChange(e, 'milestoneType')}
                                /> */}
                  {/* {filterMilestoneTypes(milestoneTypeSearch).map((milestone, index) => (
                                  <DropdownItem
                                    key={index}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelectItem(
                                        { id: milestone, name: milestone, removename: 'removemilestonetype' },
                                        selectedMilestonestype,
                                        setSelectedMilestonestype,
                                        toggleMilestonetypeDropdown
                                      );
                                    }}
                                  >
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={ismilestonetypemSelected(milestone, selectedMilestonestype)}
                                        readOnly
                                      />
                                      <label className="form-check-label">{milestone}</label>
                                    </div>
                                  </DropdownItem>
                                ))} */}

                  {/* ))} */}
                  {/* </DropdownMenu>
                            </Dropdown> */}
                  {/* Milestone Dropdown */}
                  {/* <Dropdown
                              isOpen={milestoneDropdownOpen}
                              toggle={toggleMilestoneDropdown}
                            >
                              <DropdownToggle
                                className={`btn mi-stone-bg ${timelineMilestone.length > 0 ? '' : ' disable'}`}
                                caret
          
                              >
                                Milestone
                                <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu className="p-0">
                              
                                <input
                                  type="text"
                                  placeholder="Search Milestone"
                                  className="form-control"
                                  value={milestoneSearch}
                                  onChange={(e) => handleSearchChange(e, 'milestone')}
                                />
                                {filterMilestones(milestoneSearch).map((milestone, index) => (
                                  <DropdownItem
                                    key={index}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelectItem(
                                        { id: milestone, name: milestone, removename: 'removemilestone' },
                                        selectedMilestones,
                                        setSelectedMilestones,
                                        toggleMilestoneDropdown
                                      );
                                    }}
                                  >
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={ismilestoneSelected(milestone, selectedMilestones)}
                                        readOnly
                                      />
                                      <label className="form-check-label">{milestone}</label>
                                    </div>
                                  </DropdownItem>
                                ))}
          
                               
                              </DropdownMenu>
                            </Dropdown> */}
                  <Dropdown
                    className="unit-cust-filter"
                    isOpen={unitDropdownOpen}
                    toggle={toggleUnitDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineUnit.length === 0}
                      className={`btn units-bg ${timelineUnit.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Units <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Units"
                        className="form-control"
                        value={unitSearch} // Bind the input value to the state variable
                        onChange={(e) => handleSearchChange(e, 'unitSearch')} // Pass 'unitSearch' type
                      />

                      {/* {timelineUnit.map((unit) => ( */}
                      {filterUnits(unitSearch).map((unit) => (
                        <DropdownItem
                          key={unit.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            // handleSelectItem({ id: unit.id, name: unit.name }, selectedUnits, setSelectedUnit, toggleUnitDropdown);
                            handleunitSelectItem(
                              {
                                id: unit.id,
                                name: unit.name,
                                removename: 'removeunits',
                              },
                              selectedUnits,
                              setSelectedUnits,
                              toggleUnitDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isUnitSelected(unit.id, selectedUnits)}
                              readOnly
                            />
                            <label className="form-check-label">
                              {unit.name}
                            </label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>

                  <button
                    type="button"
                    className="btn btn-primary border-0 py-1 px-3 me-1"
                    onClick={handleApply} // Close dropdowns on apply
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            {/* normal nav filter show */}
            <div className="filters-show">
              <div className="selected-filters">
                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-left"
                    onClick={handleLeftClick}
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>
                )}

                <div
                  className="filter-summary"
                  ref={filterSummaryRef}
                  onMouseDown={startDrag}
                  onMouseMove={handleMouseMove}
                  onMouseUp={stopDrag}
                  onMouseLeave={stopDrag}
                  onTouchStart={startDrag} // Touch equivalent of onMouseDown
                  onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                  onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                >
                  {selectedUniversities.size > 0 && (
                    <div
                      className={`filter-item ${showScrollButtons ? 'ft-pl' : ''
                        }`}
                    >
                      {Array.from(selectedUniversities).map((universityId) => {
                        const university = universities.find(
                          (u) => u.id === universityId,
                        );
                        return university ? (
                          <p
                            key={universityId}
                            className="filter-tag university"
                          >
                            {university.university_name}{' '}
                            {/* <i
                                        className="ri-close-line"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => removeUniversity(universityId)}
                                      ></i> */}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedPrograms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedPrograms).map((programId) => {
                        const program = programs.find(
                          ([id]) => id === programId,
                        );
                        return program ? (
                          <p key={programId} className="filter-tag programs">
                            {program[1]}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTimelines.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTimelines).map((year, index) => (
                        <p key={index} className="filter-tag year">
                          {year}
                        </p>
                      ))}
                    </div>
                  )}

                  {selectedTerms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTerms).map((term, index) => (
                        <p key={index} className="filter-tag stu-period">
                          {term}
                        </p>
                      ))}
                    </div>
                  )}
                  {selectedMilestonestype.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedMilestonestype).map(
                        (milestone, index) => (
                          <p key={index} className="filter-tag mi-stone-type">
                            {milestone}
                          </p>
                        ),
                      )}
                    </div>
                  )}
                  {selectedMilestones.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedMilestones).map(
                        (milestone, index) => (
                          <p key={index} className="filter-tag mi-stone">
                            {milestone}
                          </p>
                        ),
                      )}
                    </div>
                  )}

                  {/* Display selected units */}
                  {selectedUnits.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedUnits).map((unitId) => {
                        const unit = timelineUnit.find((u) => u.id === unitId);
                        return unit ? (
                          <p key={unitId} className="filter-tag units">
                            {unit.name}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}
                </div>

                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-right"
                    onClick={handleRightClick}
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                )}
              </div>
              <div className="">
                {hasSelections && (
                  <button
                    type="button"
                    className="clear-all-btn me-1"
                    onClick={clearAllSelections}
                  >
                    <i class="ri-close-fill"></i> Clear All
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="tab-tp-title ">
            <h3 className="bold">Individual Unit Details {UnitName || ''}</h3>
          </div>

          <div className="mt-1">
            <Card className="mb-2">
              <CardBody>
                {isApiLoading ? ( // Show spinner only when API is loading
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: '200px' }}
                  >
                    <Spinner style={{ width: '3rem', height: '3rem' }} />
                  </div>
                ) : (
                  <Row className="g-2">
                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="minty-gradient border-green mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">Unit Enrolments</p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.total_student_classroom_unit || 0}
                              </h4>
                              {/* <div className="rounded-pill-green ">
                            <p className="f-14 semibold"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-up"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M18 11l-6 -6" /><path d="M6 11l6 -6" /></svg>1%</p>
                          </div> */}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>



                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="peachy-gradient border-red mb-0 h-100 ">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">
                                New Students Enrolled
                              </p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.total_student_classroom_new_students ||
                                  0}
                              </h4>
                              {/* <div className="rounded-pill-red d-flex ">
                          <svg  xmlns="http://www.w3.org/2000/svg"  width="18"  height="18"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 5l0 14" /><path d="M18 13l-6 6" /><path d="M6 13l6 6" /></svg>
                            <p className="f-14 semibold">12%</p>
                          </div> */}
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                    </Col>

                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="lavender-gradient border-lavender mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">Teachers Deployed</p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.total_teachers_classrooms || 0}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card
                        className="minty-gradient border-green mb-0 h-100"
                        style={{
                          minHeight: '100px',
                        }}
                      >
                        <CardBody>
                          <div>
                            <div className="mb-2">
                              <p className="f-14 semibold">% Student Engaged</p>
                            </div>
                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="f-3 bold">
                                {cardsData?.students_engaged || 'N/A'}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="lavender-gradient border-lavender mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">Weekly Student Engagement</p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.average_percentage_of_students_engaged || 0}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card
                        className="peachy-gradient border-red mb-0 h-100"
                        style={{
                          minHeight: '100px',
                        }}
                      >
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">
                                % Student Engaged in 1:1 Sessions
                              </p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData
                                  ? cardsData.students_engaged_one_on_one_sessions
                                  : '0'}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>


                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="peach-blossom-gradient border-yellow mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">Weekly Student Engagement via 1-1 Sessions</p>

                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.average_percentage_of_students_engaged_in_sessions || 0}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="peach-blossom-gradient border-yellow mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">
                                {/* Avg. Session Time Per Student (Min.) */}
                                Avg. Time Spent in 1-1 Sessions Per Student (Mins)
                              </p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.average_call_per_student || 0}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card
                        className="sky-gradient border-sky mb-0 h-100 ex-link"
                        style={{ cursor: 'pointer', minHeight: '100px' }}
                      >
                        <CardBody>
                          <div>
                            <div className="mb-2">
                              <p className="f-14 semibold">
                                Total 1:1 Session Duration
                              </p>
                            </div>
                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.total_duration || '0'}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card
                        className="peachy-gradient border-red mb-0 h-100"
                        style={{
                          minHeight: '100px',
                        }}
                      >
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">
                                Number of Group Sessions
                              </p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData
                                  ? cardsData.total_group_sessions
                                  : '0'}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="peach-blossom-gradient border-yellow mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">Messages Responded Within 60 Mins</p>
                            </div>

                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {(cardsData?.message_responded_within_60mins || 0) + "%"}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>




                    <Col xxl={2} xl={3} lg={4} sm={6}>
                      <Card className="peach-blossom-gradient border-yellow mb-0 h-100">
                        <CardBody>
                          <div className="">
                            <div className="mb-2">
                              <p className="f-14 semibold">Avg. Grading Quality Score</p>
                            </div>
                            <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                              <h4 className="bold">
                                {cardsData?.avg_grading_quality_score || 0}
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    {/* {JSON.stringify(cardsData)} */}
                  </Row>
                )}
              </CardBody>
            </Card>

            <div ref={tabsRef} style={{ scrollMarginTop: 90 }}>
            <Nav className="mb-0 d-sm-flex d-block" tabs>
              <NavItem>
                <NavLink
                  className={activeTab === 'all' ? 'active' : ''}
                  active={activeTab === 'all'}
                  onClick={() => toggleTab('all')}
                  style={{ cursor: 'pointer', marginRight: '2px' }}
                >
                  Unit
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'teachers' ? 'active' : ''}
                  active={activeTab === 'teachers'}
                  onClick={() => toggleTab('teachers')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Staff
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className={activeTab === 'insights' ? 'active' : ''}
                  active={activeTab === 'insights'}
                  onClick={() => toggleTab('insights')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Insights
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink
                  className={activeTab === 'Student List' ? 'active' : ''}
                  active={activeTab === 'Student List'}
                  onClick={() => toggleTab('Student List')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Student List
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === '1-1 Session Insights' ? 'active' : ''}
                  active={activeTab === '1-1 Session Insights'}
                  onClick={() => toggleTab('1-1 Session Insights')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  1-1 Session Insights
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'Group Session Insights' ? 'active' : ''}
                  active={activeTab === 'Group Session Insights'}
                  onClick={() => toggleTab('Group Session Insights')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Group Session Insights
                </NavLink>
              </NavItem>
            </Nav>
            </div>

            {/*section2*/}
            {activeTab === 'all' && (
              <div>
                <Card className="mb-2">
                  {isApiLoading ? ( // Show spinner only when API is loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <CardBody>
                      <Row className="g-2">
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Student Engagement
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={clusteredColumnChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Census Melt Rate (%)
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={clusteredColumnChartOptionsForCensus}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Unit Completion Rate
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={
                                    clusteredColumnChartOptionsForUnitCompletion
                                  }
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Student Feedback
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={studentSatisfactionChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>


                {/*section4*/}
                <Card className="mb-2">
                  {isApiLoading ? ( // Show spinner only when API is loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <CardBody>
                      <Row className="g-2">
                        <Col md={6} className="mb-0">
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Student Engagement by Week
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={lineChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          {/* <Card className="mb-0 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Proportion of Active Students Engaged in &gt;=
                                  50% Weeks
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={studentReengagementChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card> */}
                          <Card className="mb-0 border box-shadow-none">
                            <PlotBarChart
                              suffix=""
                              title="Student Re-engagement Till Date"
                              yAxisTitle="No of Active Students Engaged"
                              xAxisTitle="Number of Weeks Engaged"
                              barColors={[
                                '#add8e6',
                                '#add8e6',
                                '#add8e6',
                                '#add8e6',
                              ]}
                              options={studentReengagementChart}
                            />
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  1-1 Session Details, by Week
                                </h5>
                                <HighchartsReact
                                  ref={studentSessionchartRef}
                                  highcharts={Highcharts}
                                  options={combinedChartOptions}
                                /> */}



                                <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
                                    1-1 Session Details, by Week
                                  </ChartTitle>
                                  <HighchartsReact
                                    ref={studentSessionchartRef}
                                    highcharts={Highcharts}
                                    options={chartNav(combinedChartOptions, TAB.ONE_TO_ONE)}
                                  />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6} className="mb-0 ">
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  1-1 Session Duration, by Week
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={lineChartOptions1}
                                /> */}

                                <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  1-1 Session Duration, by Week
</ChartTitle>
<HighchartsReact
  highcharts={Highcharts}
  options={chartNav(lineChartOptions1, TAB.ONE_TO_ONE)}
/>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6} className="mb-0">
                          {/* <Card className="mb-0 h-100 border box-shadow-none"> */}
                          <Card className=" h-100 border box-shadow-none">
                            <CardBody>
                              <div className="h-100">
                                <h5 className="f-16 bold d-flex align-items-center mb-0">
                                  Messages Exchanged, by Week
                                </h5>
                                <div className="d-flex flex-column justify-content-center h-100">
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={stackedGroupedChartOptions}
                                  />
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Message Responsiveness (%)
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={donutChartOptions1}
                                />
                                <div className="d-flex flex-sm-row flex-column gap-2 pt-2">
                                  <div className="data-card-value dcv-1">
                                    <p className="data-val">
                                      {messageResponsiveness?.['0-1hrs'] ??
                                        '0%'}
                                    </p>
                                    <p className="data-label">Within 60 min</p>
                                  </div>
                                  <div className="data-card-value dcv-2">
                                    <p className="data-val">
                                      {messageResponsiveness?.['1-2hrs'] ??
                                        '0%'}
                                    </p>
                                    <p className="data-label">In 1-2 hrs</p>
                                  </div>
                                  {/* <div className="data-card-value dcv-5">
                                    <p className="data-val">{messageResponsiveness?.["2-4hrs"] ?? "0%"}</p>
                                    <p className="data-label">In 2-4 hrs</p>
                                  </div> */}
                                </div>
                                <div className="d-flex gap-2 pt-2">
                                  <div className="data-card-value dcv-6">
                                    <p className="data-val">
                                      {messageResponsiveness?.['2-6hrs'] ??
                                        '0%'}
                                    </p>
                                    <p className="data-label">In 2-6 hrs</p>
                                  </div>
                                  <div className="data-card-value dcv-4">
                                    <p className="data-val">
                                      {messageResponsiveness?.above_6_hrs ??
                                        '0%'}
                                    </p>
                                    <p className="data-label">
                                      In More than 6 hrs
                                    </p>
                                  </div>
                                  <div className="data-card-value dcv-3">
                                    <p className="data-val">
                                      {messageResponsiveness?.not_responded ??
                                        '0%'}
                                    </p>
                                    <p className="data-label">Not Responded</p>
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>
                <Card className="mb-2">
                  {isApiLoading ? ( // Show spinner only when API is loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <CardBody>
                      <Row className="g-2">
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            {/* <CardBody className=" ">
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Student Health
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={studentHealthChartOptions}
                                />
                              </div>
                            </CardBody> */}


                            <CardBody>
                              <div className="">
                                <ChartTitle onClick={() => goToTab(TAB.STUDENT_LIST)} hint="View student list">
                                  Student Health
                                </ChartTitle>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={withChartNavigation(studentHealthChartOptions, () => goToTab(TAB.STUDENT_LIST))}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Assessment Discussion with Students
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={assessmentDiscussionChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </Card>
                {/*section5*/}
                <Card className="mb-2">
                  {isApiLoading ? ( // Show spinner only when API is loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <CardBody>
                      <Row className="g-2">
                        {/* <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Session based Red Flags
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={redFlagsPercentageChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col> */}
                        {/* <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center  mb-3">
                                  Instructor Feedback
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={lfRedFlagsByCategoryChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col> */}
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  1-1 Session Quality Score
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={callQualityChartOptions}
                                /> */}



                                <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  1-1 Session Quality Score
</ChartTitle>
<HighchartsReact
  highcharts={Highcharts}
  options={chartNav(callQualityChartOptions, TAB.ONE_TO_ONE)}
/>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        {/* <Col md={6}>
                          <Card className="mb-0 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5
                                  className="f-16 bold d-flex align-items-center mb-3"
                                >
                                  Assessment Grading Quality Score
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}

                                  options={gradingScoresChartOptions}
                                />
                              </div>

                            </CardBody>
                          </Card>
                        </Col> */}

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Grading Quality Score
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={gradingQualityChartOptions}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  1-1 Sessions by Type
                                </h5>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={oneToOneChart}
                                /> */}


                                <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  1-1 Sessions by Type
</ChartTitle>
<HighchartsReact
  highcharts={Highcharts}
  options={withChartNavigation(oneToOneChart, () => goToTab(TAB.ONE_TO_ONE))}
/>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Group Session Details by Week
                                </h5> */}
                                <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  Group Session Details by Week
</ChartTitle>
                                <HighchartsReact

                                  highcharts={Highcharts}
                                  options={chartNav(Groupsessionbyweekchart, TAB.GROUP_SESSION)}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col md={6} className="mb-0">
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <CardBody>
                              <div className="">
                                {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                  Group Session Quality Score
                                </h5> */}

                                <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
 Group Session Quality Score
</ChartTitle>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={chartNav(GroupsessionQualitycorce, TAB.GROUP_SESSION)}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                      </Row>
                    </CardBody>
                  )}
                </Card>

              </div>
            )}
            {activeTab === 'teachers' && (
              <div>
                <Row className="g-2 mb-2">
                  <Col xs={12}>
                    <Card className="mb-0">
                      {isApiLoading ? ( // Show spinner only when API is loading
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: '200px' }}
                        >
                          <Spinner style={{ width: '3rem', height: '3rem' }} />
                        </div>
                      ) : (
                        <CardBody>
                          <h5 className="f-16 bold d-flex align-items-center mb-3">
                            Summary
                          </h5>
                          <div className="">
                            <TeacherTable tacherTableData={tacherTableData} />
                          </div>
                        </CardBody>
                      )}
                    </Card>
                  </Col>
                </Row>
                <div>
                  <Card className="mb-2">
                    <CardBody>
                      <div>
                        <Row className="g-2 mt-0">
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Student Engagement Till Date
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={studentEngagementChartOptions}
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Student Re-engagement Till Date
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={
                                        studentEngagement50WeeksChartOptions
                                      }
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div>
                  <Card className="mb-2">
                    <CardBody>
                      <div>
                        <Row className="g-2 mt-0">
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Student Engagement Activity
                                    </h5>
                                    <HighchartsReact
                                      ref={chartRef}
                                      highcharts={Highcharts}
                                      options={chartOptions}
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Message Responsiveness Till Date
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={responsivenesschartinteacher}
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div>
                  <Card className="mb-2">
                    <CardBody>
                      <div>
                        <Row className="g-2 mt-0">
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Mid-Term Student Feedback
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={
                                        studentfeedbackmidtermChartOptions
                                      }
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      End-Term Student Feedback
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={
                                        studentfeedbackendtermChartOptions
                                      }
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Group Session Activity
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={
                                        groupSessionsByTeachersChartConfig
                                      }
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Session Quality Score
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={
                                        sessionQualityScoreChart
                                      }
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="mb-0 h-100 border box-shadow-none">
                              {isApiLoading ? ( // Show spinner only when API is loading
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: '200px' }}
                                >
                                  <Spinner
                                    style={{ width: '3rem', height: '3rem' }}
                                  />
                                </div>
                              ) : (
                                <CardBody>
                                  <div className="">
                                    <h5 className="f-16 bold d-flex align-items-center mb-3">
                                      Grading Quality Scores
                                    </h5>
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={
                                        gradingQualityChartOptionsbyteacher
                                      }
                                    />
                                  </div>
                                </CardBody>
                              )}
                            </Card>
                          </Col>

                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
            {/* {activeTab === 'insights' && (
              <div>
                <Row className="g-2 mb-2">
                  <Col xs={12}>
                    <Card className="mb-0">
                      <CardBody>
                        <div className="d-flex flex-wrap gap-2">
                          <div className="flex-grow-1">
                          </div>
                          <div className="ind-un-re">
                            <div className="d-flex   justify-content-end flex-wrap gap-2">
                              <Dropdown
                                isOpen={weekDropdownOpen}
                                toggle={toggleWeekDropdown}
                              >
                                <DropdownToggle
                                  className={`btn stu-period-bg ${
                                    weeks.length > 0 ? '' : 'disable'
                                  }`}
                                  caret
                                >
                                  Weeks <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>

                                <DropdownMenu
                                  className="p-0"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <input
                                    type="text"
                                    placeholder="Search week"
                                    className="form-control"
                                    value={weekSearch}
                                    onChange={(e) =>
                                      handleSearchChange(e, 'week')
                                    } // Fixed here
                                  />

                                  {filterWeeks(weekSearch).map(
                                    (week, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSelectItem(
                                            {
                                              id: week,
                                              name: week,
                                              removename: 'removeweek',
                                            },
                                            selectedWeeks,
                                            setSelectedWeeks,
                                            toggleWeekDropdown,
                                          );
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={selectedWeeks.has(week)}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            {week}
                                          </label>
                                        </div>
                                      </DropdownItem>
                                    ),
                                  )}
                                </DropdownMenu>
                              </Dropdown>

                              <button
                                type="button"
                                className="btn btn-primary border-0 py-1 px-3 me-1"
                                onClick={handleApply} // Close dropdowns on apply
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="filters-show">
                            <div className="selected-filters">
                              {showScrollButtons && (
                                <button
                                  className="slider-button slider-button-left"
                                  onClick={handleLeftClick}
                                >
                                  <i className="ri-arrow-left-s-line"></i>
                                </button>
                              )}

                              <div
                                className="filter-summary"
                                ref={filterSummaryRef}
                                onMouseDown={startDrag}
                                onMouseMove={handleMouseMove}
                                onMouseUp={stopDrag}
                                onMouseLeave={stopDrag}
                                onTouchStart={startDrag} // Touch equivalent of onMouseDown
                                onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                                onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                              >
                                {selectedWeeks.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedWeeks).map(
                                      (weeks, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag mi-stone-type"
                                        >
                                          {weeks}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>

                              {showScrollButtons && (
                                <button
                                  className="slider-button slider-button-right"
                                  onClick={handleRightClick}
                                >
                                  <i className="ri-arrow-right-s-line"></i>
                                </button>
                              )}
                            </div>
                            <div className="">
                              {hasSelections && (
                                <button
                                  type="button"
                                  className="clear-all-btn me-1"
                                  onClick={clearAllSelections1}
                                >
                                  <i class="ri-close-fill"></i> Clear All
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                        {loading1 ? ( // Show loader while loading
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                          >
                            <Spinner
                              style={{ width: '3rem', height: '3rem' }}
                            />
                          </div>
                        ) : (
                          <div className="mt-2">
                            <FaqTable isightsData={isightsData} />
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            )} */}
            {activeTab === 'Student List' && (
              <div>
                <Row className="g-2 mb-2">
                  <Col xs={12}>
                    <Card className="mb-0">
                      <CardBody>
                        <div className="d-flex flex-wrap gap-2">
                          <div className="flex-grow-1">
                            <h5 className="f-16 bold">Student List</h5>
                          </div>
                        </div>
                        <div className="mt-2">
                          <StudentListTable
                            StudentLIst={StudentLIst}
                            appliedUniversities={
                              (appliedUniversities.size > 0 &&
                                appliedUniversities) ||
                              Deatilsofunits?.appliedUniversities
                            }
                            appliedPrograms={
                              (appliedPrograms.size > 0 && appliedPrograms) ||
                              Deatilsofunits?.appliedPrograms
                            }
                            appliedTimelines={
                              (appliedTimelines.size > 0 && appliedTimelines) ||
                              Deatilsofunits?.appliedTimelines
                            }
                            appliedTerms={
                              (appliedTerms.size > 0 && appliedTerms) ||
                              Deatilsofunits?.appliedTerms
                            }
                            appliedUnit={
                              (appliedUnit.size > 0 && appliedUnit) ||
                              (Deatilsofunits?.unit_id
                                ? new Set([Deatilsofunits.unit_id])
                                : new Set())
                            }
                          />
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
            {activeTab === '1-1 Session Insights' && (
              <>
                <Row className="g-2 mt-1">
                  <Col xs={12}>
                    
                        <TopicDiscussedTab
                          resetTrigger={resetTrigger}
                          fullURL={
                            process.env.REACT_APP_API_BASE_URL +
                            'individual_unit_report/'
                          }
                          payload={payload}
                          isApiLoading={isApiLoading}
                          // urlWeek={urlWeek}

                          urlWeek={drillWeek ?? urlWeek}

                          initialSubTab={drillSubTab}

                          onStudentClick={handleFlaggedStudentClick}
                        />
                      
                  </Col>
                </Row>
                <Row className="g-2 mb-2">
                  <Col xs={12}>
                    {Call_performance_response ? (

                      <Card className="mb-0">
                        <CardBody>
                          {isApiLoading ? (
                            <Card
                              className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner />
                            </Card>
                          ) : (
                            <Row className="g-2">
                              <Col md={6}>
                                <Card className="mb-0 h-100 border box-shadow-none">
                                  <OnetoOneSessionQualityScore
                                    xAxisTitle=""
                                    options={
                                      Call_performance_response?.weekly_call_quality_scores
                                    }
                                  />
                                </Card>
                              </Col>
                              <Col md={6}>
                                <Card className="mb-0 h-100 border box-shadow-none">
                                  <ClarityScoreChart
                                    xAxisTitle=""
                                    options={
                                      Call_performance_response?.weekly_clarity_scores
                                    }
                                  />
                                </Card>
                              </Col>
                              <Col md={6}>
                                <Card className="mb-0 h-100 border box-shadow-none">
                                  <EngagementScoreChart
                                    xAxisTitle=""
                                    options={
                                      Call_performance_response?.weekly_engagement_scores
                                    }
                                  />
                                </Card>
                              </Col>

                              <Col md={6}>
                                <Card className="mb-0 h-100 border box-shadow-none">
                                  <AssessmentDiscussionChart
                                    xAxisTitle=""
                                    title={' Assessment Discussion (%)'}
                                    options={
                                      Call_performance_response?.weekly_assessment_discussed_student
                                    }
                                  />
                                </Card>
                              </Col>
                              <Col md={6}>
                                <Card className="mb-0 h-100 border box-shadow-none">
                                  <AssessmentDiscussionDraftChart
                                    xAxisTitle=""
                                    options={
                                      Call_performance_response?.weekly_draft_discussed_student
                                    }
                                  />
                                </Card>
                              </Col>
                              <Col md={6}>
                                <Card className="mb-0 h-100 border box-shadow-none">
                                  <StudentSentimentChart
                                    options={
                                      Call_performance_response?.weekly_student_sentiments
                                    }
                                  />

                                  {/* <PlotBarChart
                                  suffix=""
                                  title="Proportion of Active Students Engaged in &gt;= 50% Weeks"
                                  yAxisTitle="No of Active Students Engaged"
                                  xAxisTitle="Sentiments"
                                  barColors={[
                                    '#add8e6',
                                    '#add8e6',
                                    '#add8e6',
                                    '#add8e6',
                                  ]}
                                  options={
                                    Call_performance_response?.weekly_student_sentiments
                                  }
                                /> */}
                                </Card>
                              </Col>

                            </Row>
                          )}
                        </CardBody>
                      </Card>
                    ) : (
                      <>
                        {isApiLoading ? (
                          <Card
                            className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                          >
                            <Spinner />
                          </Card>
                        ) : (
                          <Card
                            className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                          >
                            No Call Perfomance is available for chosen metrics
                            or Choose different metrics
                          </Card>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </>
            )}

            {activeTab === "Group Session Insights" && (
              <>
               
                  
                      <WebinarInsightsTab
                        resetTrigger={resetTrigger}
                        fullURL={
                          process.env.REACT_APP_API_BASE_URL + "individual_unit_report/"
                        }
                        payload={payload}
                        isApiLoading={isApiLoading}

                        urlWeek={drillWeek}
                      />
                   
                <Row className="g- mb-2">
                  <Card className="mb-0">
                    <CardBody>
                      {webinarPerfomanceData?.weekly_assessment_discussed ? (
                        isApiLoading ? (
                          <Card
                            className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                          >
                            <Spinner />
                          </Card>
                        ) : (
                          <Row lg={12}>
                            <WebinarAverageCharts
                              {...webinarAverageChartsDataProps}
                            />
                            <Col md={6}>
                              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                                <PlotBarChart
                                  xAxisTitle="Date"
                                  title="% Sessions: Assessment Discussed"
                                  yAxisTitle="% of Sessions"
                                  barColors={assessmentDiscussedColor}
                                  options={
                                    webinarPerfomanceData?.weekly_assessment_discussed
                                  }
                                  suffix="%"
                                />
                              </Card>
                            </Col>

                            <Col md={6}>
                              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                                <PlotBarChart
                                  xAxisTitle="Week"
                                  title="% Sessions: Slides Used"
                                  yAxisTitle="% of Sessions"
                                  barColors={slidesUsedColor}
                                  options={
                                    webinarPerfomanceData?.weekly_is_slides_used
                                  }
                                  suffix="%"
                                />
                              </Card>
                            </Col>
                            <Col md={6}>
                              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                                <PlotBarChart
                                  xAxisTitle="Week"
                                  title="% Sessions: Interactive Tools Used"
                                  yAxisTitle="% of Sessions"
                                  barColors={interactiveToolsColor}
                                  options={
                                    webinarPerfomanceData?.weekly_interactive_tools_used
                                  }
                                  suffix="%"
                                />
                              </Card>
                            </Col>
                          </Row>
                        )
                      ) : (
                        <>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              minHeight: 170,
                            }}
                          >
                            <Typography
                              variant="p"
                              color="text.secondary"
                              align="center"
                            >
                              Webinar Performance charts are not available
                            </Typography>
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Row>
              </>
            )}

          </div>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>

      <style scoped>
        {`
        .data-card-value{
          width: 100%;
          padding: 12px;
          border: 1px solid #E8E8E9;
          border-radius: 6px;
        }
        .data-val{
          font-size: 16px;
          font-weight: bold;
          color: #1c1c1c;
        }
        .data-val{
          font-size: 14px;
        }
         .dcv-1{
          position: relative;
        }
        .dcv-1::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(235,255,238,1) 0%, rgba(162,234,179,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-2{
           position: relative;
        }
        .dcv-2::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(230,238,255,1) 0%, rgba(183,208,246,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-3{
           position: relative;
        }
        .dcv-3::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
          background: linear-gradient(180deg, rgba(255,210,210,1) 0%, rgba(247,148,150,1) 100%);
      
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-4{
          position: relative;
        }
        .dcv-4::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background:linear-gradient(180deg, rgba(230,238,255,1) 0%, rgba(147,151,255,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-5{
           position: relative;
        }
        .dcv-5::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(255,239,225,1) 0%, rgba(255,229,205,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
         .dcv-6{
           position: relative;
        }
        .dcv-6::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, #96bdc900 0%, #53839299 100%);
        border-radius: 0px 32px 32px 0px;
        }
        @media (max-width:1199px) {
          .charts-card{
            display: flex;
            gap: 16px;
          }
        }
        @media (max-width:560px) {
          .charts-card{
            flex-wrap: wrap;
          }
        }
      `}
      </style>
    </React.Fragment>
  );
};

export default IndividualUnitReport;
